import React, { useEffect, useRef, useState } from 'react'
import { Modal } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { parse, addMinutes, format, isDate, isBefore, isAfter } from 'date-fns';
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import DatePicker from "../General/DatePicker";
import ModalHeader from '../Setup/Shared/ModalHeader';
import SearchHeader from '../Setup/Shared/SearchHeader';
import FormValidator from '../../utils/FormValidator';
import { enumUtil } from '../../utils/Enum';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import NotificationHandler from '../../utils/NotificationHandler';
import Loader from '../shared/Loader/Loader';
import { useSelector } from 'react-redux';
import isNull from '../../utils/NullChecking';
import { checkTimeFormat } from '../../utils/Constants';
import { momentLocalizer } from 'react-big-calendar';
import { formatedDate } from '../../utils/Constants';
import moment from 'moment';
import DeleteConfirmatiom from '../General/DeleteConfirmation';
import AmountFormatter from '../../utils/AmountFormatter';
import { FindFirstChild } from '../../utils/FindMenuOption';
import PatientSearch from '../shared/AdvanceSearches/PatientSearch';
import AddNewPat from '../shared/AddNewPatient/AddNewPat';
import SuperSearchMultipleClient from '../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import DropdownValueHandler from '../shared/SuperSearch/DropdownValueHandler';
import StatusConfirmationPopup from './StatusConfirmationPopup/StatusConfirmationPopup';
import Audit from '../General/Audit';
import IntakePreview from './IntakePreview/IntakePreview';
import MarkAsNoShowPopup from "./MarkAsNoShowPopup/MarkAsNoShowPopup";
import RecurringPopup from './RecurringPoup/RecurringPopup';
import AvailableSlotsDropdown from './AvailableSlotsDropDown/AvailableSlotsDropdown';
import RejectedIntakeFormPopup from './RejectedIntakeFormPopup/RejectedIntakeFormPopup';
import { isEqual } from 'lodash';
import BlockConfirmation from './BlockConfirmation/BlockConfirmation';
import ActiveAlert from '../General/ActiveAlert';
import handleNumericCheck from '../../utils/HandleNumericKeys';
import { useDispatch } from 'react-redux';
import ReloadGridAction from '../../actions/ReloadGridAction';
import { MainTabContentActiveTab, MainTabContentTabList } from '../../actions/SidebarAction';
import isAmountNull from '../../utils/AmountNullChecker';
import EncounterMenu from '../Encounter Menu/EncounterMenu';
import { TabActionEncounterMenu } from '../../actions/EncounterMenuActions';
import EncounterMenuSearch from '../Encounter Menu/EncounterMenuSearch';
import AddNewBlockAppointment from './AddNewBlockAppointment';
import AddNewCPTAppointment from './AddNewCPTAppointment';
import { set } from 'lodash';
import SuperSearchMultipleServer from '../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer';
import GroupAppointmentPatientSection from './GroupAppointmentPatientSection';
import CustomUseRef from '../shared/DropDown/CustomUseRef';
import DeleteGroupAppointment from '../General/DeleteGroupAppointment';

const AddNewAppointment = (props) => {
    let IsEditAllowed = FindFirstChild('Scheduler', 'Appointment')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Scheduler', 'Appointment')?.IsDeleted;
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let setting = useSelector(state => state?.SettingsReducer)
    let IsTelehealthEnabled = setting?.TeleHealthEnable
    //console.log(setting, 'setting');


    const [isTeleHealth, setIsTeleHealth] = useState(false)
    const isLive = process.env.REACT_APP_ISLIVE
    const localizer = momentLocalizer(moment);
    const { PatientID, setIsBlocked, isBlocked, providersScheduler, timeSLot, showEvents, handleOnClose, handleOnCloseSave, mainEventModal, choosenDate, AppointmentID, providerID, locationID, getAppointments, getProvider, getLocation, openedFrom, SelectedTypeProps } = { ...props };
    const [timeSlot, setTimeSlot] = useState(timeSLot ? timeSLot : null);
    const dropDownReducer = useSelector((state) => { return state.GeneralDropDownsReducer });
    const formattedDate = moment().format('MM/DD/YYYY');
    const providersList = dropDownReducer.Provider;
    //console.log(providersList, 'providersList');
    let CheifComplaintRequired = useSelector(state => state.SettingsReducer?.CheifComplaintRequired);
    let EnableGroupAppointments = useSelector(state => state.SettingsReducer?.EnableGroupAppointments);
    let GroupNameRequired = useSelector(state => state.SettingsReducer?.GroupNameRequired);


    const locationList = dropDownReducer.Location;
    const [visitTypeList, setVisitTypeList] = useState(dropDownReducer.AppointmentType || []);
    // const visitTypeList = dropDownReducer.AppointmentType;
    const appointmentStatusList = dropDownReducer.AppointmentStatus;
    const appointmentStatusListTeleHealth = dropDownReducer.AppointmentStatus.filter(
        item => item.value === 11 || item.value === 12 || item.value === 6
    );
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer);
    const currentDate = DropdownData?.CurrentPracticeDate;
    let dispatch = useDispatch();
    let IntakeDropDown = DropdownData?.IntakeFormList;
    //console.log(choosenDate, 'choosenDate');

    const [AppoimentModeDD, setAppointmentDD] = useState([
        { value: '', display: '' },
        { value: 'In-Person', display: 'In-Person' },
        ...(isTeleHealth
            ? [{ value: 'Telehealth', display: 'Telehealth' }]
            : [])
    ]);

    useEffect(() => {
        setAppointmentDD([
            { value: '', display: '' },
            { value: 'In-Person', display: 'In-Person' },
            ...(isTeleHealth
                ? [{ value: 'Telehealth', display: 'Telehealth' }]
                : [])
        ]);
    }, [isTeleHealth]);

    let EmailNotification = useSelector((state) => state.SettingsReducer?.EmailNotification) || false;
    let Appointment_Modal = {
        PatientID: null,
        AppointmentStatusID: '',
        AppointmentStatus: 'Scheduled',
        Status: "",
        InsuranceID: null,
        InsuranceName: "",
        ChiefComplain: "",
        ProviderID: '',
        ProviderName: '',
        LocationID: '',
        LocationName: '',
        AppointmentStartTime: mainEventModal?.start + "",
        AppointmentEndTime: mainEventModal?.end + "",
        AppointmentStart: null,
        AppointmentEnd: null,
        DurationID: null,
        AppointmentTypeID: null,
        AppointmentType: "",
        Notes: "",
        AppointmentDate: currentDate,
        IsBlocked: "0",
        SMSNotification: false,
        EmailNotification: EmailNotification,
        ProcedureCode: '',
        EHRTemplate: '',
        IntakeForm: [],
        AppointmentMode: '',
    }
    let Block_Modal = {
        LocationID: '',
        LocationName: '',
        ProviderID: '',
        ProviderName: '',
        BlockOption: null,
        AppointmentStart: "",
        AppointmentEnd: "",
        AppointmentStartTime: mainEventModal?.start + "",
        AppointmentEndTime: mainEventModal?.end + "",
        AppointmentDate: choosenDate ? choosenDate : currentDate,
        ProviderSchedulerStartTime: '',
        ProviderSchedulerEndTime: '',
        AllDay: "",
        Notes: "",
        IsBlocked: 0 + "",
        Reason: ''
    }
    let Patient_Modal = {
        Age: '',
        DOB: '',
        Email: '',
        PatientName: '',
        Copay: '',
        InsuranceName: '',
        PatientBalance: '',
        MobileNumber: '',
        PatientInsuranceID: '',
        PatientID: '',
        ProfilePicture: '',
        AccountNumber: '',
    }
    let Insurace_Modal = {
        ID: '0',
        SubscriberID: '',
        CoveragePriority: '',
        InsuranceName: '',
    }
    let ReasonDD = [
        { value: 'Lunch', display: 'Lunch' },
        { value: 'Meeting', display: 'Meeting' },
        { value: 'Out of office', display: 'Out of office' },
        { value: 'Surgery', display: 'Surgery' },
        { value: 'Vocation', display: 'Vocation' },
    ]
    let Scheduled_Slot_Modal = {
        SlotsSchedule: 'Scheduled',
    }
    let valModal = {}
    let validationModal = {
        LocationID: "",
        ChiefComplain: "",
        ProviderID: "",
        AppointmentStatus: "",
        AppointmentTypeID: "",
        AppointmentDate: "",
        AppointmentStart: "",
        AppointmentEnd: "",
        DurationID: "",
        Patient: "",
        AppointmentMode: '',
        GroupNameVal: ''
    }
    /////////////////////Block Validation Modal
    let BlockValidation_Modal = {
        LocationID: '',
        ProviderID: '',
        BlockOption: '',
        StartTime: '',
        EndTime: '',
        AppointmentDate: '',
        Reason: '',
    }
    let BlockValModal = {}

    let intake_Modal = {
        intakeFormIDs: '',
    }
    let IntakeStatusDD = [
        { value: 'Submitted', display: 'Submitted' },
        { value: 'Merged', display: 'Merged' },
        { value: 'Rejected', display: 'Rejected' },
    ]
    const [providerScheduler, setProviderScheduler] = useState(providersScheduler ? providersScheduler : {})
    const [headerVal, setHeaderVal] = useState("")
    const [activeTab, setActiveTab] = useState('Weekly');
    const [selectedType, setSelectedType] = useState(SelectedTypeProps || 'Individual');
    const [allPatientDetails, setAllPatientDetails] = useState([])
    const [showParticipant, setShowParticipant] = useState(false);
    const [AppointChildModal, setAppointChildModal] = useState(false);
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [InsuranceID, setInsuranceID] = useState();
    const [availableSlots, setAvailableSlots] = useState([]);
    const [availableStartTimeSlots, setAvailableStartTimeSlots] = useState([]);
    const [availableEndTimeSlots, setAvailableEndTimeSlots] = useState([]);
    const [BlockAvailableStartTimeSlots, setBlockAvailableStartTimeSlots] = useState([]);
    const [BlockAvailableEndTimeSlots, setBlockAvailableEndTimeSlots] = useState([]);
    const [filteredAvailableSlots, setfilteredAvailableSlots] = useState([]);
    const [notScheduledFilteredArray, setNotScheduledFilteredSlots] = useState([]);
    const [provID, setProvID] = useState(providerID);
    const [locID, setLocID] = useState(locationID);
    const [slotDate, setSlotDate] = useState(choosenDate ? choosenDate : currentDate);
    const [responseByID, setResponseByID] = useState(null);
    const [appointmentID, setAppointmentID] = useState(null);
    const [isOpenPatSearch, setisOpenPatSearch] = useState(false)
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [selectedClaimId, setSelectedClaimID] = useState([])
    const [intakeFormIDs, setIntakeFormIDs] = useState(intake_Modal);
    const [reloadSuperSearch, setReloadSuperSearch] = useState(false);
    const [SelfPayPatient, setSelfPayPatient] = useState(false);
    const [IsSlotAvailable, setIsSlotAvailable] = useState(false);
    const [EHRTemplateID, setEHRTemplateID] = useState(0);
    const [IsMarkAsNoShowOpen, setIsMarkAsNoShowOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isRecurringPopupOpen, setIsRecurringPopupOpen] = useState();
    const [intakeStatusValue, setIntakeStatusValue] = useState('Submitted');
    const [AlertData, setAlertData] = useState([]);
    // const [isLoading, setLoading] = useState(null);

    const prevFilterRef = useRef({
        isRefresh: false,
        slotDate: choosenDate ? choosenDate : currentDate,
        provID: '',
        locID: '',
    });
    const initialRef = useRef(true);
    const getAvailableSlots = (isEmpty) => {
        setAvailableSlots([]);
        setAvailableStartTimeSlots([]);
        setIsSlotAvailable(false);
        setAvailableEndTimeSlots([]);
        setCounter(0);
        // setIsLoading(true);
        let saveModal = {
            SEARCHCRITERIA: {
                ProviderID: provID + "",
                LocationID: locID + "",
                Date: slotDate,
            },
            TABLENAME: enumUtil.enumAPITableName.Scheduler,
        }
        ServerRequestProtected(API_URi + "/AvailableSlots", "POST", saveModal)
            .then((response) => {
                // setIsLoading(false);
                if (response) {
                    const AvailableStartTimeSlots = response?.StartTime ? response?.StartTime : [];
                    const AvailableEndTimeSlots = response?.EndTime ? response?.EndTime : [];
                    setAvailableSlots(response);
                    setIsSlotAvailable(true);
                    let availableStartSlots = AvailableStartTimeSlots?.filter((slot) => slot?.InScheduled === "1" && slot?.IsScheduled === "0");
                    let availableEndSlots = AvailableEndTimeSlots?.filter((slot) => slot?.InScheduled === "1" && slot?.IsScheduled === "0");
                    setAvailableStartTimeSlots(AvailableStartTimeSlots);
                    setAvailableEndTimeSlots(AvailableEndTimeSlots);
                    setBlockAvailableStartTimeSlots(availableStartSlots);
                    setBlockAvailableEndTimeSlots(availableEndSlots);
                    // setfilteredAvailableSlots(response);
                }
            })
            .catch((error) => {
                // setIsLoading(false);
                setIsSlotAvailable(false);
                // NotificationHandler("No Slots Available", enumUtil.enumtoaster.error);
                // if (isEmpty) {
                // setMainAppointmentModal({ ...mainAppointmentModal, AppointmentStart: "", AppointmentEnd: "" })
                // setSaveAppointmentModal({ ...saveAppointmentModal, AppointmentStart: "", AppointmentEnd: "" })
                setSaveAppointmentModal((prev) => {
                    return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
                })
                setMainAppointmentModal((prev) => {
                    return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
                })
                // }
            })
    }

    const isTimeMatched = (AppointmentStartTime, timeList) => {
        const appointmentTime = new Date(AppointmentStartTime).toLocaleTimeString(
            'en-US',
            {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            }
        );

        return timeList.some(item => item.StartTime === appointmentTime);
    };
    const getAvailableSlotsByParam = (providerID, locationID, appointmentDate, mainModal, save) => {
        // if (!isNull(mainModal?.AppointmentStartTime)) {
        //     setMainAppointmentModal(mainModal)
        //     setSaveAppointmentModal(save)
        // }

        setAvailableSlots([]);
        setAvailableStartTimeSlots([]);
        setIsSlotAvailable(false);
        setAvailableEndTimeSlots([]);
        setCounter(0);
        setIsLoading(true);
        let saveModal = {
            SEARCHCRITERIA: {
                ProviderID: providerID + "",
                LocationID: locationID + "",
                Date: appointmentDate,
            },
            TABLENAME: enumUtil.enumAPITableName.Scheduler,
        }
        ServerRequestProtected(API_URi + "/AvailableSlots", "POST", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (response) {
                    const AvailableStartTimeSlots = response?.StartTime ? response?.StartTime : [];
                    const AvailableEndTimeSlots = response?.EndTime ? response?.EndTime : [];
                    setAvailableSlots(response);
                    setIsSlotAvailable(true);
                    let availableStartSlots = AvailableStartTimeSlots?.filter((slot) => slot?.InScheduled === "1" && slot?.IsScheduled === "0");
                    let availableEndSlots = AvailableEndTimeSlots?.filter((slot) => slot?.InScheduled === "1" && slot?.IsScheduled === "0");
                    if (!isNull(mainModal?.AppointmentStartTime)) {
                        let result = isTimeMatched(mainModal?.AppointmentStartTime, availableStartSlots)
                        if (!result) {
                            setMainAppointmentModal({ ...mainModal, AppointmentEnd: '', AppointmentStart: '' })
                            setSaveAppointmentModal({ ...save, AppointmentEnd: '', AppointmentStart: '' })
                        } else {
                            setMainAppointmentModal(mainModal)
                            setSaveAppointmentModal(save)
                        }
                    }
                    setAvailableStartTimeSlots(AvailableStartTimeSlots);
                    setAvailableEndTimeSlots(AvailableEndTimeSlots);
                    setBlockAvailableStartTimeSlots(availableStartSlots);
                    setBlockAvailableEndTimeSlots(availableEndSlots);
                }
            })
            .catch((error) => {
                // NotificationHandler("No Slots Available", enumUtil.enumtoaster.error);
                setIsLoading(false);
                setIsSlotAvailable(false);
                if (!isNull(mainModal)) {
                    setMainAppointmentModal({ ...mainModal, AppointmentEnd: '', AppointmentStart: '' })
                    setSaveAppointmentModal({ ...save, AppointmentEnd: '', AppointmentStart: '' })
                } else {
                    setSaveAppointmentModal((prev) => {
                        return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
                    })
                    setMainAppointmentModal((prev) => {
                        return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
                    })
                }

            })
    }

    ///////////////////////////// handleBlockAppointmentTime
    const handleAppointmentTime = (data, providerID, blockType) => {
        let start = data?.AppointmentStart ? data?.AppointmentStart : "12:00 AM";
        let end = data?.AppointmentEnd ? data?.AppointmentEnd : "12:00 PM";
        if (blockType) {
            const providerSchedule = providerScheduler?.[providerID]?.[0];
            start = providerSchedule?.TimeFrom || "12:00 AM";
            end = providerSchedule?.TimeTo || "12:00 PM";
            data['AppointmentStart'] = start;
            data['AppointmentEnd'] = end;
        }
        const slotDate = data?.AppointmentDate;
        const [timeStart, periodStart] = start.split(" ");
        const [hours, minutes] = timeStart.split(":");
        const [timeEnd, periodEnd] = end.split(" ");
        const [hrs, mints] = timeEnd.split(":");
        const startHours24 = periodStart === 'AM' ? hours % 12 : (parseInt(hours, 10) % 12) + 12;
        const endHours24 = periodEnd === 'AM' ? hrs % 12 : (parseInt(hrs, 10) % 12) + 12;
        const [month, day, year] = slotDate.split('/');
        const formatedStartDate = new Date(year, month - 1, day, startHours24, minutes);
        const formatedEndDate = new Date(year, month - 1, day, endHours24, mints);
        return { ...data, AppointmentStartTime: formatedStartDate + "", AppointmentEndTime: formatedEndDate + "" }
    }
    const getIntakeDD = () => {
        ServerRequestProtected(API_URi + '/DropDown', 'POST', {
            "TableName": "EhrTemplate"
        }).then((response) => {
            let data = response
            data = data.filter(item => item.TemplateType !== 'Clinical Form')
            // //console.log('data', data);

            // setIntakeDropDown(data);
            if ([0, "0", null].includes(AppointmentID)) {
                let defaultIntakeForm = response?.filter((item) => {
                    return (item?.IsDefault === 'true' && item?.value !== -1);
                });
                let defaultIntakeFormArray = defaultIntakeForm?.map((item) => item?.value);
                let defaultIntakeFormValues = defaultIntakeFormArray?.join(", ");
                setIntakeValue(defaultIntakeForm);
                setSaveAppointmentModal((prev) => {
                    return [0, "0", null].includes(AppointmentID)
                        ? { ...prev, EHRTemplate: defaultIntakeFormValues }
                        : { ...prev }
                })
            }
            setReloadSuperSearch((prev) => !prev);
        }).catch((error) => {
            // setIntakeDropDown([]);
            setReloadSuperSearch((prev) => !prev);
        })
    }
    const timeConversion24To12Hrs = (time) => {
        let time12 = "";
        const time24 = time;
        if (!isNull(time24)) {
            time12 = moment(time24, "HH:mm:ss").format("hh:mm A");
        }
        return time12;
    }
    const timeParser = (time, minutes) => {
        let formate = checkTimeFormat(time);
        const baseTime = (formate === '12-hour format' && parse(time, 'h:mm a', new Date())) || (formate === '24-hour format' && parse(time, 'HH:mm:ss', new Date()));
        let formattedTime;
        if (minutes) {
            const baseTime = (formate === '12-hour format' && parse(time, 'h:mm a', new Date())) || (formate === '24-hour format' && parse(time, 'HH:mm:ss', new Date()));
            const newTime = addMinutes(baseTime, minutes);
            formattedTime = format(newTime, 'HH:mm:ss');
        } else {
            formattedTime = format(baseTime, 'hh:mm a');
        }
        return formattedTime
    }
    const handleStatusColor = (status) => {
        switch (status) {
            case "Awaiting Response": return "Hold";
            case "Submitted": return "Submitted";
            case "Merged": return "Paid";
            case "Rejected": return "Rejected";
            case "Deleted": return "Denied";
            default: return "Submitted";

        }
    }
    const handleStatusBasedActions = (status, onClickFunc) => {
        switch (status) {
            case "Awaiting Response": return <span className="ar-light-color" onClick={onClickFunc}> (<span className="validate-color cursor-pointer">Resend</span>)</span>;
            case "Submitted": return <span className='ms-2'><button className={"btn btn-validate h-100 min-w-unset px-2 py-2px rounded"} onClick={onClickFunc}> Review</button></span>;
            case "Merged": return <></>;
            case "Rejected": return <span className="ar-light-color" onClick={onClickFunc}>(<span className="validate-color cursor-pointer"> Resend</span>)</span>;
            case "Not Sent": return <span className="ar-light-color" onClick={onClickFunc}>(<span className="validate-color cursor-pointer"> Resend</span>)</span>;
            default: return <></>;
        }
    }
    const [blockAppointmentValidation, setBlockAppointmentValidation] = useState(BlockValidation_Modal);
    const [mainBlockAppointmentModal, setMainBlockAppointmentModal] = useState(Block_Modal);
    const [saveBlockAppointmentModal, setSaveBlockAppointmentModal] = useState(() => {
        if (!isNull(responseByID)) {
            return {}
        } else {
            return {
                AppointmentDate: Appointment_Modal.AppointmentDate,
                ProviderID: Appointment_Modal.ProviderID && Appointment_Modal.ProviderID,
                IsBlocked: 1 + "",
                LocationID: Appointment_Modal.LocationID && Appointment_Modal.LocationID
            }
        }
    });
    const [patientDetails, setPatientDetails] = useState(Patient_Modal);
    const slotStartTime = mainEventModal?.start?.toString().split(' ')[4];
    const startTime12HrsFormat = slotStartTime && timeParser(slotStartTime);
    const slotEndTime = mainEventModal?.end?.toString().split(' ')[4];
    const endTime12HrsFormat = slotEndTime && timeParser(slotEndTime);
    const [reloadSuperSearchIntake, setReloadSuperSearchIntake] = useState(false);
    const [IntakeValue, setIntakeValue] = useState([]);
    const [intakeBody, setIntakeBody] = useState({
        Search: "",
        SearchType: "Intake",
    });
    const [isLocationUpdate, setIsLocationUpdate] = useState(false)
    const [IsCopayUpdate, setIsCopayUpdate] = useState(false)
    const [calendarSidebar, setCalendarSidebar] = useState(false)
    const [isRefresh, setIsRefresh] = useState(false);
    const [Patientid, setPatientID] = useState(PatientID);
    const [isOpendFromPatient, setIsOpendFromPatient] = useState(false)
    const [PatientName, setPatientName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [appointmentValidation, setAppointmentValidation] = useState(validationModal);
    const [mainAppointmentModal, setMainAppointmentModal] = useState(Appointment_Modal);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [IntakeFormStatus, setIntakeFormStatus] = useState('');
    const [saveAppointmentModal, setSaveAppointmentModal] = useState(() => {
        if (!isNull(responseByID)) {
            return {}
        } else {
            return { AppointmentDate: Appointment_Modal.AppointmentDate, ProviderID: Appointment_Modal.ProviderID, LocationID: Appointment_Modal.LocationID }
        }
    });
    const [mainClaimInsuModal, setmainClaimInsuModal] = useState([]);
    const [duration, setDuration] = useState([]);
    const [insuranceDD, setInsuranceDD] = useState([])
    const [patientBody, setPatientBody] = useState({ "TableName": "", "SearchParam": '' })
    const API_URL = enumUtil.controller.Patient;
    const API_URl = enumUtil.controller.Claim;
    const API_URI = enumUtil.controller.PatientPayment;
    const API_URi = enumUtil.controller.General;
    const timeGutterFormat = 'ha';
    const [addAppointment, setaddAppointment] = useState(false);
    const [dateFromCalendar, setDateFromCalendar] = useState(formattedDate);
    const [is, setIs] = useState(true);
    const [del, setDel] = useState(false);
    const [patientModal, setPatientModal] = useState(false);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [patientSearch, setPatientSearch] = useState(true)
    const [chunkedArray, setChunkedArray] = useState([])
    const [filterstatus, setFilterstatus] = useState(false);
    const [counter, setCounter] = useState(0);
    // const [IntakeDropDown, setIntakeDropDown] = useState([]);
    const [SlotSchedule, setSlotSchedule] = useState('Scheduled');
    const [IsOpenStatusConfirmation, setIsOpenStatusConfirmation] = useState(false);
    const [IsOpenIntakePreview, setIsOpenIntakePreview] = useState(false);
    const [previousStatus, setPreviousStatus] = useState({ StatusName: '', StatusID: '' });
    const [isRepeats, setIsRepeats] = useState(false);
    const [IsSingular, setIsSingular] = useState(true);
    const [StatusArray, setStatusArray] = useState([]);
    const [FilteredStatusArray, setFilteredStatusArray] = useState([]);
    const [isStatus, setIsStatus] = useState(false);
    const [RejectedConfirmation, setRejectedConfirmation] = useState(false);
    const [SelectedIntakeFormID, setSelectedIntakeFormID] = useState(0);
    const [SelectedIntakeFormName, setSelectedIntakeFormName] = useState("");
    const [oldIntakeStatus, setOldIntakeStatus] = useState({ index: '', status: '' });
    const [AppointmentIsInFuture, setAppointmentIsInFuture] = useState(false);
    const [IsBlockConfirmation, setIsBlockConfirmation] = useState(false);
    const [isAlertVisible, setAlertVisible] = useState(false);
    const [IntakeFormID, setIntakeFormID] = useState(null);
    const [SelectedPatientID, setSelectedPatientID] = useState(null)
    const makeMultiSelectArray = (data, values) => {
        //console.log(data, values);

        if (isNull(values)) return [];
        const selectedValues = values
            .split(',')
            .map(item => item.trim());

        return data?.filter(item =>
            selectedValues.includes(item.value?.toString())
        );
    }
    const FindByID = () => {
        if ([0, "0", null].includes(AppointmentID)) {
            setDel(false);
            setAppointmentID(0);
            setHeaderVal("Add New Appointment");

            setSaveAppointmentModal({})
        } else {
            setDel(true)
            setAppointmentID(AppointmentID);
            setHeaderVal(mainAppointmentModal.Status);
            setIsLoading(true)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientAppointment,
                ID: AppointmentID,
            }
            ServerRequestProtected(API_URL + "/FindByID", "POST", saveModal).then((response) => {
                setIsLoading(false);
                setIs(true)
                // getAvailableSlotsByParam(response?.ProviderID, response?.LocationID, response?.AppointmentDate);
                response['ProID'] = response?.ProviderID
                response['LocID'] = response?.LocationID
                setProvID(response?.ProviderID + "")
                setLocID(response?.LocationID + "")
                let selectedProvider = providersList?.find((item) => item.value === response?.ProviderID);
                if (!isNull(selectedProvider) && selectedProvider.IsStaff && selectedProvider.EnableScheduling) {
                    let appointmentTypeDD = makeMultiSelectArray(dropDownReducer.AppointmentType, selectedProvider?.AllowAppointmentType)
                    setVisitTypeList(appointmentTypeDD);
                } else {
                    setVisitTypeList(dropDownReducer.AppointmentType)
                }
                let ProviderData = DropDowns?.Provider?.find(
                    item => String(item.value) === String(response.ProviderID)
                );
                if (ProviderData.DoxyStatusURL === 'Active' && !isNull(ProviderData.DoxyURL) && IsTelehealthEnabled) {
                    setIsTeleHealth(true)
                } else {
                    setIsTeleHealth(false)
                }
                response['ProviderID'] = DropdownValueHandler(providersList, response?.ProviderID)
                response['LocationID'] = DropdownValueHandler(locationList, response?.LocationID)
                response['AppointmentTypeID'] = DropdownValueHandler(dropDownReducer.AppointmentType, response?.AppointmentTypeID)
                response['AppointmentStatusID'] = DropdownValueHandler(appointmentStatusList, response?.AppointmentStatusID)
                if (response.IsGroupAppointment) {
                    setSelectedType('Group')
                }
                setResponseByID(response);
                setSelfPayPatient(response?.IsSelfPayPatient);
            }).catch((error) => {
                setIsLoading(false);
            })
        }
    }
    useEffect(() => {
        if (choosenDate) {
            setDateFromCalendar(choosenDate);
            let modal = { ...mainAppointmentModal };
            modal['AppointmentDate'] = choosenDate;
            setMainAppointmentModal(modal);
            setSaveAppointmentModal({ ...saveAppointmentModal, AppointmentDate: choosenDate })
            setMainBlockAppointmentModal({ ...mainBlockAppointmentModal, AppointmentDate: choosenDate })
            setSaveBlockAppointmentModal({ ...saveBlockAppointmentModal, AppointmentDate: choosenDate })
        }
    }, [choosenDate])
    useEffect(() => {
        if (mainEventModal && availableStartTimeSlots?.length === 0 && availableEndTimeSlots?.length === 0 && !responseByID) {
            const slotStartTime = mainEventModal?.start?.toString().split(' ')[4];
            const slotEndTime = mainEventModal?.end?.toString().split(' ')[4];
            setMainAppointmentModal((prev) => ({ ...prev, AppointmentStartTime: mainEventModal?.start + "", AppointmentEndTime: mainEventModal?.end + "", AppointmentStart: timeConversion24To12Hrs(slotStartTime) }));
            setSaveAppointmentModal((prev) => ({ ...prev, AppointmentStartTime: mainEventModal?.start + "", AppointmentEndTime: mainEventModal?.end + "", AppointmentStart: timeConversion24To12Hrs(slotStartTime) }));
        }
        if (providerID) {
            setProvID(providerID + "")
        }
    }, [mainEventModal, availableStartTimeSlots])
    useEffect(() => {
        let array = [15, 30, 45, 60];
        let formattedArray = []
        if (!isNull(timeSlot)) {
            let durations = array.filter((slot) => {
                if (timeSlot == 45) {
                    return slot == 45;
                } else {
                    return slot >= timeSlot && (60 % slot) === 0;
                }
            })
            durations?.map((item) => {
                let obj = { value: item, display: item };
                formattedArray.push(obj)
            })
            setDuration(formattedArray);
        }

    }, [timeSlot])
    useEffect(() => {
        FindByID()
    }, [AppointmentID])
    useEffect(() => {
        if (isNull(AppointmentID)) {
            if (openedFrom === 'Patient') {
                setIsOpendFromPatient(true)
            } else {
                setIsOpendFromPatient(false)
            }
            if (!isNull(PatientID)) {
                GetPatientInsurances(PatientID);
                FindPatientInsurances(PatientID);
                setPatientID(PatientID);
            }
            let modal = { ...mainAppointmentModal };
            let saveModal = { ...saveAppointmentModal };
            let blockModal = { ...mainBlockAppointmentModal };
            let saveBlockModal = { ...saveBlockAppointmentModal };
            if (locationList?.length === 2) {
                modal['LocationID'] = locationList[1].display + "";
                saveModal['LocationID'] = locationList[1].value + "";
                blockModal['LocationID'] = locationList[1].display + "";
                saveBlockModal['LocationID'] = locationList[1].value + "";
                setLocID(locationList[1].value + "");
            }
            if (providersList?.length === 2) {
                modal['ProviderID'] = providersList[1].display + "";
                saveModal['ProviderID'] = providersList[1].value + "";
                blockModal['ProviderID'] = providersList[1].display + "";
                saveBlockModal['ProviderID'] = providersList[1].value + "";
                setProvID(providersList[1].value + "");
            }
            if (visitTypeList.length === 2) {
                modal['AppointmentTypeID'] = visitTypeList[1].display
                saveModal['AppointmentTypeID'] = visitTypeList[1].value + ""
            }
            if (AppoimentModeDD.length === 2) {
                modal['AppointmentMode'] = AppoimentModeDD[1].display
                saveModal['AppointmentMode'] = AppoimentModeDD[1].value + ""
            }
            modal['SMSNotification'] = EmailNotification;
            saveModal['EmailNotification'] = EmailNotification + "";
            setMainAppointmentModal(modal);
            setSaveAppointmentModal(saveModal);
            setMainBlockAppointmentModal(blockModal);
            setSaveBlockAppointmentModal(saveBlockModal);
        } else {
        }
        if (!isNull(providerID) && !isNull(locationID) && !isNull(choosenDate)) {
            getAvailableSlots(false);
        }
    }, [])
    const masterHeader = () => {
        if (!isNull(mainAppointmentModal.Status)) {
            return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>{mainAppointmentModal.Status}</p>;
        } else {
            return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>Add Appointment</p>;
        }
    };
    ////////////Duration Drop Down /////////////
    const handleDuration = (providerID, type) => {
        if (type === 'durationClaim') {
            if (!isNull(providerID)) {
                let steps = providerID?.[0]?.TimeSlot;
                if (!isNull(steps)) {
                    setTimeSlot(steps)
                } else {
                    setTimeSlot(30);
                }
            } else {
                setTimeSlot(30);
            }
        }
        else {
            if (providerScheduler && providerScheduler[providerID]?.length != 0) {
                let steps = providerScheduler[providerID]?.[0]?.TimeSlot;
                if (!isNull(steps)) {
                    setTimeSlot(steps)
                } else {
                    setTimeSlot(30);
                }
            } else {
                setTimeSlot(30);
            }
        }
    }
    ////////////////// Appointment On  Change /////////////
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        const modal = { ...mainAppointmentModal }
        const saveModal = { ...saveAppointmentModal }
        modal[name] = value
        setMainAppointmentModal(modal);
        for (let property in Appointment_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSaveAppointmentModal(saveModal);
    }
    const handleOnChange = (e) => {
        let isChecked;
        const modal = { ...mainAppointmentModal }
        const saveModal = { ...saveAppointmentModal }
        let startTime;
        let { name, value, checked } = e.target;
        if (name === 'ProviderID') {
            handleDuration(value);
            setProvID(value + "");
        }
        if (name === 'LocationID') {
            setLocID(value + "");
        }
        if (name === 'AppointmentStart') {
            startTime = value;
            if (!isNull(mainAppointmentModal.DurationID)) {
                const endTimes = timeParser(startTime ? startTime : mainAppointmentModal.AppointmentStart, mainAppointmentModal.DurationID);

                modal["AppointmentEnd"] = endTimes;
                saveModal["AppointmentEnd"] = endTimes;
                handleTimeSlots(saveModal, value);
            }
        }
        if (name === 'DurationID') {
            const duration = e.target.value;
            if (!isNull(mainAppointmentModal.AppointmentStart)) {
                const endTimes = timeParser(mainAppointmentModal.AppointmentStart, duration);
                modal["AppointmentEnd"] = endTimes;
                saveModal["AppointmentEnd"] = endTimes;
                handleTimeSlots(saveModal);
            }
        }
        if (name === 'InsuranceID') {
            modal['InsuranceName'] = e.target.options[e.target.selectedIndex].text;
        }
        if (name === 'SMSNotification' || name === 'EmailNotification') {
            isChecked = e.target.checked
            value = isChecked;
        }
        modal[name] = value == '-1' ? "" : value;
        setMainAppointmentModal(modal);
        for (let property in modal) {
            if (name === property) {
                saveModal[name] = value + "";
            }
        }
        setSaveAppointmentModal(saveModal);
    }
    ///////////// handleOpenStatusConfirmationPopup ///////////
    const handleOpenStatusConfirmationPopup = (modal) => {
        setIsOpenStatusConfirmation(true);
    }
    const onCloseStatusConfirmation = () => {
        let modal = { ...mainAppointmentModal }
        const { Reason, ...saveModal } = saveAppointmentModal;
        modal['AppointmentStatus'] = previousStatus?.StatusName;
        modal['AppointmentStatusID'] = previousStatus?.StatusName + "";
        saveModal['AppointmentStatus'] = previousStatus?.StatusName;
        saveModal['AppointmentStatusID'] = previousStatus?.StatusID + "";
        setMainAppointmentModal(modal);
        setSaveAppointmentModal(saveModal);
        setIsOpenStatusConfirmation(false);

    }
    const onCloseStatusConfirmationSave = () => {
        setIsOpenStatusConfirmation(false);
    }
    let ConfirmStatusChangePopup = "";
    if (IsOpenStatusConfirmation) {
        ConfirmStatusChangePopup = <StatusConfirmationPopup isPopupOpen={IsOpenStatusConfirmation} onClose={onCloseStatusConfirmation} name={"Reason"} searchParam={saveAppointmentModal} setSearchParam={setSaveAppointmentModal} modal={mainAppointmentModal} handleSave={onCloseStatusConfirmationSave} isLoading={isLoading} />
    }
    ////// Intake Form Status /////// 
    const handleIntakeStatus = (status, formID) => {
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": formID,
            "Data": {
                "IntakeStatus": status
            }
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/ChangeIntakeFormStatus', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
                setIntakeStatusValue(status);

                setRejectedConfirmation(false);
                FindByID();
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.message, enumUtil.enumtoaster.error);
            })
    }
    const handleRejectedConfimation = (formName, formID) => {
        setRejectedConfirmation(true);
        setSelectedIntakeFormID(formID);
        setSelectedIntakeFormName(formName);
    }
    const CloseRejectedConfimation = () => {
        setRejectedConfirmation(false);
        let modalArray = [...IntakeValue];
        setIntakeValue(modalArray);
    }
    let RejectionConfirmation = "";
    if (RejectedConfirmation) {
        RejectionConfirmation = <RejectedIntakeFormPopup isDiscardChanges={RejectedConfirmation} handleCancelDiscard={CloseRejectedConfimation} onProceedWithDiscardChanges={handleIntakeStatus} FormName={SelectedIntakeFormName} FormID={SelectedIntakeFormID} isLoading={isLoading} />
    }
    //////////////////// handle copay change in patient details /////////////
    const handleOnChangeCopay = (e) => {
        const { name, value } = e.target;
        let modal = { ...patientDetails }
        let saveModal = { ...saveAppointmentModal }
        modal[name] = value;
        saveModal[name] = value;
        setSaveAppointmentModal(saveModal);
        setPatientDetails(modal);
    }
    ////////////////// handleAppointmentSelectedData /////////////
    const handleAppointmentSelectedData = (selectedData, name, type) => {
        const modal = { ...mainAppointmentModal }
        const saveModal = { ...saveAppointmentModal }
        setIs(true)
        if (!isNull(selectedData)) {
            if (name === 'ProviderID') {
                modal['ProviderName'] = selectedData?.display + '';
                modal['AppointmentStart'] = '';
                saveModal['AppointmentStart'] = '';

                handleDuration(selectedData?.value);
                setProvID(selectedData?.value + "");
                saveModal[name] = selectedData?.value + ''
                if (selectedData.DoxyStatusURL === 'Active' && !isNull(selectedData.DoxyURL) && IsTelehealthEnabled) {
                    setIsTeleHealth(true)
                } else {
                    setIsTeleHealth(false)
                }
                let appointmentTypeDD = []
                if (!isNull(selectedData) && selectedData.IsStaff && selectedData.EnableScheduling) {
                    appointmentTypeDD = makeMultiSelectArray(dropDownReducer.AppointmentType, selectedData?.AllowAppointmentType)
                    setVisitTypeList(appointmentTypeDD);
                } else {
                    setVisitTypeList(dropDownReducer.AppointmentType)
                }
                if (appointmentTypeDD.length === 1) {
                    modal['AppointmentTypeID'] = appointmentTypeDD[0].display
                    saveModal['AppointmentTypeID'] = appointmentTypeDD[0].value + ""
                    modal["AppointmentType"] = appointmentTypeDD[0]?.display;
                    const duration = appointmentTypeDD[0]?.Duration;
                    getProceduresByAppointmentType(appointmentTypeDD[0].value)
                    if (!isNull(duration)) {
                        modal["DurationID"] = duration;
                        saveModal["DurationID"] = duration;
                    }
                    if (!isNull(mainAppointmentModal.AppointmentStart) && !isNull(duration)) {
                        // modal["DurationID"] = duration;
                        const endTimes = timeParser(mainAppointmentModal.AppointmentStart, duration);
                        modal["AppointmentEnd"] = endTimes;
                        saveModal["AppointmentEnd"] = endTimes;
                        handleTimeSlots(saveModal);
                    }
                } else {
                    modal['AppointmentTypeID'] = ''
                    saveModal['AppointmentTypeID'] = ''
                    modal["AppointmentType"] = ''
                }

                getAvailableSlotsByParam(selectedData?.value + "", locID, modal?.AppointmentDate);
            }
            if (name === 'LocationID') {
                setLocID(selectedData?.value + "");
                modal['LocationName'] = selectedData?.display + ''
                saveModal[name] = selectedData?.value + ''
                getAvailableSlotsByParam(provID, selectedData?.value + "", modal?.AppointmentDate);
            }
            if (name === 'DurationID') {
                const duration = selectedData?.value;
                if (!isNull(mainAppointmentModal.AppointmentStart)) {
                    const endTimes = timeParser(mainAppointmentModal.AppointmentStart, duration);
                    modal["AppointmentEnd"] = endTimes;
                    saveModal["AppointmentEnd"] = endTimes;
                    handleTimeSlots(saveModal);
                }
            }
            if (name === 'AppointmentMode') {
                modal['AppointmentMode'] = selectedData?.display;
                saveModal['AppointmentMode'] = selectedData?.value + '';
            }
            if (name === 'InsuranceID') {
                modal['InsuranceName'] = selectedData?.display;
            }
            if (name === "AppointmentTypeID") {
                modal["AppointmentType"] = selectedData?.display;
                const duration = selectedData?.Duration;
                getProceduresByAppointmentType(selectedData.value)
                if (!isNull(duration)) {
                    modal["DurationID"] = duration;
                    saveModal["DurationID"] = duration;
                }
                if (!isNull(mainAppointmentModal.AppointmentStart) && !isNull(duration)) {
                    // modal["DurationID"] = duration;
                    const endTimes = timeParser(mainAppointmentModal.AppointmentStart, duration);
                    modal["AppointmentEnd"] = endTimes;
                    saveModal["AppointmentEnd"] = endTimes;
                    handleTimeSlots(saveModal);
                }
            }
            if (name === "AppointmentStatusID") {
                // setIsStatus(true);
                let StatusName = selectedData?.display;
                let StatusID = selectedData?.value;
                // if (StatusName === mainAppointmentModal?.AppointmentStatus) {
                //     return
                // }
                if (StatusName === "In Room" || StatusName === "Change Room") {
                    modal['Reason'] = modal?.reason;
                    handleOpenStatusConfirmationPopup(modal);
                }
                else if (StatusName === "No Show" || StatusName === "Cancelled") {
                    handleMarkAsNoShowPopup(StatusName === "No Show" ? 'NoShow' : "Cancelled");
                }
                setPreviousStatus((prev) => {
                    if (!["No Show", "Cancelled", "In Room", "Change Room"].includes(StatusName)) {
                        return { StatusName: StatusName, StatusID: StatusID }
                    } else {
                        return prev
                    }
                });
                modal['AppointmentStatus'] = StatusName
                // modal['AppointmentStatusID'] = StatusName

            }
            modal[name] = selectedData?.value == '-1' ? "" : selectedData?.display;


            for (let property in modal) {
                if (name === property) {
                    saveModal[name] = selectedData?.value + "";
                }
            }

        } else {
            modal[name] = "";
            saveModal[name] = "";
        }
        //console.log(modal, selectedData, 'selectedData');

        setMainAppointmentModal(modal);
        setSaveAppointmentModal(saveModal);
    }
    const [ProcedureCodeData, setProcedureCodeData] = useState([])
    const getProceduresByAppointmentType = (id) => {
        ServerRequestProtected(API_URi + "/FindByMultipleCriteria", 'post', {
            "ID": id + "",
            "TableName": enumUtil.enumAPITableName.AppointmentTypeProcedureCode
        }).then((response) => {
            setProcedureCodeData(response.Rows);
        }).catch((error) => {
            setProcedureCodeData([])
        })
    }
    ////////////////// handle Intake Form Status selected /////////////
    const handleBlockSelectedData = (selectedData, name, type) => {
        const modal = { ...mainBlockAppointmentModal };
        const saveModal = { ...saveBlockAppointmentModal };
        modal[name] = selectedData?.value;
        if (name === "ProviderID") {
            modal['ProviderID'] = selectedData?.display
            setProvID(selectedData?.value);
        }
        if (name === "LocationID") {
            modal["LocationID"] = selectedData?.display;
            setLocID(selectedData?.value);
        }
        if (name === "AppointmentTypeID") {
            modal["AppointmentType"] = selectedData?.display;
        }
        setMainBlockAppointmentModal(modal);
        for (let property in modal) {
            if (name === property) {
                saveModal[property] = selectedData?.value + "";
            }
        }
        setSaveBlockAppointmentModal(saveModal);
    }
    ////////////////// Appointment On  Change StartTime /////////////
    const handleOnChangeStartTime = (e, name, value) => {
        const modal = { ...mainAppointmentModal }
        const saveModal = { ...saveAppointmentModal }
        let startTime;
        startTime = value;
        if (!isNull(mainAppointmentModal.DurationID)) {
            const endTimes = timeParser(startTime ? startTime : mainAppointmentModal.AppointmentStart, mainAppointmentModal.DurationID);
            modal["AppointmentEnd"] = endTimes;
            saveModal["AppointmentEnd"] = endTimes;
            handleTimeSlots(saveModal, value);
        }
        modal[name] = value == '-1' ? "" : value;
        saveModal[name] = value + "";
        setMainAppointmentModal(modal);
        setSaveAppointmentModal(saveModal);
        closeDropdown();

    }
    //////////////////////////////// Block On  Change
    const handleOnChangeBlock = (e) => {
        const { name, value, checked, type } = e.target;
        const modal = { ...mainBlockAppointmentModal };
        const saveModal = { ...saveBlockAppointmentModal }
        if (type === "checkbox") {
            modal[name] = checked
        } else {
            modal[name] = value;
        }
        if (name === "ProviderID") {
            setProvID(value);
        }
        if (name === "LocationID") {
            setLocID(value);
        }
        setMainBlockAppointmentModal(modal);
        for (let property in modal) {
            if (name === property) {
                if (type === "checkbox") {
                    saveModal[name] = checked + ""
                } else {
                    saveModal[name] = value + "";
                }
            }
        }
        setSaveBlockAppointmentModal(saveModal);
    }
    const handleCalendarChange = (date, type) => {
        const dateObj = isDate(date) ? date : parse(date, "MM/dd/yyyy", new Date());
        let formatDate = format(dateObj, "MM/dd/yyyy");
        if (type === "appointment") {
            let modal = { ...mainAppointmentModal }
            let saveModal = { ...saveAppointmentModal }
            let isDateInFututre = compareDateToCurrentDate(formatDate);
            if (![0, "0", null].includes(AppointmentID) && isDateInFututre) {
                modal['AppointmentStatus'] = 'Scheduled';
                saveModal['AppointmentStatus'] = 'Scheduled';
                modal['AppointmentStatusID'] = '1';
                saveModal['AppointmentStatusID'] = '1';
            }
            modal['AppointmentDate'] = formatDate;
            saveModal['AppointmentDate'] = formatDate;
            modal['AppointmentStart'] = "";
            saveModal['AppointmentStart'] = "";
            getAvailableSlotsByParam(provID, locID, formatDate);
            setMainAppointmentModal(modal);
            setSaveAppointmentModal(saveModal);
        }
        if (type === "block") {
            setMainBlockAppointmentModal({ ...mainBlockAppointmentModal, AppointmentDate: formatDate });
            setSaveBlockAppointmentModal({ ...saveBlockAppointmentModal, AppointmentDate: formatDate });
        }
        setSlotDate(formatDate)
    }
    const appointmentFormValidtion = () => {
        let validationModal = {
            ...(CheifComplaintRequired && { ChiefComplain: FormValidator(mainAppointmentModal.ChiefComplain, enumUtil.enumValidationType.Required, "Chief Complain"), }),
            ProviderID: FormValidator(mainAppointmentModal.ProviderID, enumUtil.enumValidationType.Required, "Provider"),
            Patient: FormValidator(mainAppointmentModal.PatientID, enumUtil.enumValidationType.Required, "Patient"),
            AppointmentTypeID: FormValidator(mainAppointmentModal.AppointmentTypeID, enumUtil.enumValidationType.Required, "Type"),
            AppointmentDate: FormValidator(mainAppointmentModal.AppointmentDate, enumUtil.enumValidationType.Required, "Appointment Date"),
            AppointmentStart: FormValidator(mainAppointmentModal.AppointmentStart, enumUtil.enumValidationType.Required, "Start Time"),
            AppointmentEnd: FormValidator(mainAppointmentModal.AppointmentEnd, enumUtil.enumValidationType.Required, "End Time"),
            DurationID: FormValidator(mainAppointmentModal.DurationID, enumUtil.enumValidationType.Required, "Duration"),
            LocationID: FormValidator(mainAppointmentModal.LocationID, enumUtil.enumValidationType.Required, "Location"),
            AppointmentMode: FormValidator(mainAppointmentModal.AppointmentMode, enumUtil.enumValidationType.Required, "Appointment Mode"),
            ...(selectedType === "Group" && GroupNameRequired && {
                GroupNameVal: FormValidator(
                    mainAppointmentModal.GroupName,
                    enumUtil.enumValidationType.Required,
                    "Group Name"
                ),
            }),
        }
        setAppointmentValidation(validationModal);
        valModal = validationModal;
    }
    /////////////////////////////////////BLOCK FORM VALIDATiON
    const BlockFormValidation = () => {
        let Validation_Modal = {
            LocationID: FormValidator(mainBlockAppointmentModal.LocationID, enumUtil.enumValidationType.Required, 'Location'),
            ProviderID: FormValidator(mainBlockAppointmentModal.ProviderID, enumUtil.enumValidationType.Required, 'Provider'),
            StartTime: (!mainBlockAppointmentModal?.AllDay ? FormValidator(mainBlockAppointmentModal.AppointmentStart, enumUtil.enumValidationType.Required, 'Start Time') : ""),
            EndTime: (!mainBlockAppointmentModal?.AllDay ? FormValidator(mainBlockAppointmentModal.AppointmentEnd, enumUtil.enumValidationType.Required, 'End Time') : ""),
            AppointmentDate: FormValidator(mainBlockAppointmentModal.AppointmentDate, enumUtil.enumValidationType.Required, 'Appointment Date'),
            Reason: FormValidator(mainBlockAppointmentModal.Reason, enumUtil.enumValidationType.Required, 'Reason'),
        }
        setBlockAppointmentValidation(Validation_Modal);
        valModal = Validation_Modal;
    }
    //////////////////// Patient Search and Select Patient
    const handlePateintChange = (e) => {
        setAppointmentValidation(validationModal)
        setIs(false);
        let { name, value } = e.target;
        setPatientName(value);
        setPatientBody({ "TableName": enumUtil.enumAPITableName.PatientAppointment, "SearchParam": value })
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainAppointmentModal }
        let SaveModal = { ...saveAppointmentModal }
        if (name === 'PatientID' && !isNull(selectedData)) {
            // debugger
            if (selectedData.value != -1) {
                modal[name] = selectedData.value;
                setPatientID(selectedData.value + "")
                setPatientName(selectedData.display)
                setSelfPayPatient(selectedData.IsSelfPayPatient)
            } else {
                setPatientID("")
                setPatientName("")
            }
            let patientCopay = !isNull(selectedData.copay) ? selectedData.copay + "" : '0';
            SaveModal['PatientID'] = selectedData.value + "";
            SaveModal['Copay'] = patientCopay;
            handleSelectedPatientData(selectedData, name, type);
        } else if (name === 'AppointmentStart' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            SaveModal[name] = selectedData.value;
        } else if (name === 'AppointmentEnd' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            SaveModal[name] = selectedData.value;
        }
        else {
            setPatientID("")
            setPatientName("")
        }
        setMainAppointmentModal(modal);
        setSaveAppointmentModal(SaveModal);
    }

    const handleSelectedPatientData = (selectedData, name, type) => {
        let modal = { ...mainAppointmentModal };
        setIs(true)
        if (type === 'server' && !isNull(selectedData)) {
            if (name === 'PatientID') {
                setPatientName(selectedData.display)
                modal[name] = selectedData.display
                saveAppointmentModal[name] = selectedData.value + "";
                let patientCopay = !isNull(selectedData.copay) ? selectedData.copay + "" : '0';
                setSaveAppointmentModal({ ...saveAppointmentModal, PatientID: selectedData.value + "", Copay: patientCopay });
                FindPatientInsurances(selectedData.value)
                GetPatientInsurances(selectedData.value)
            }
        } else {
            if (name === 'PatientID') {
                setMainAppointmentModal(Appointment_Modal)
            }
            modal[name] = ''
            saveAppointmentModal[name] = ''
        }
        setMainAppointmentModal(modal)
        return selectedData
    }
    // Generic Fuunctions
    const FindPatientInsurances = (ID) => {
        setInsuranceDD([])
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/FindPatientInsuranceDetails", 'post', {
            "ID": ID + "",
            "TableName": enumUtil.enumAPITableName.PatientInsurance
        }).then((response) => {
            setIsLoading(false);
            setInsuranceDD(response);
        }).catch((error) => {
            setIsLoading(false);
            setInsuranceDD([])
        })
    }
    const [gender, setGender] = useState("");

    const handleAppointmentTypeDD = (ProviderID) => {
        let selectedProvider = providersList?.find((item) => item.value + "" === ProviderID + "");
        let appointmentTypeDD = []
        if (!isNull(selectedProvider) && selectedProvider.IsStaff && selectedProvider.EnableScheduling) {
            appointmentTypeDD = makeMultiSelectArray(dropDownReducer.AppointmentType, selectedProvider?.AllowAppointmentType)
            setVisitTypeList(appointmentTypeDD);
        } else {
            appointmentTypeDD = dropDownReducer.AppointmentType
            setVisitTypeList(dropDownReducer.AppointmentType)
        }
        return appointmentTypeDD
    }
    const GetPatientInsurances = (PatientID) => {
        if (!isNull(PatientID)) {
            setIsLoading(true);
            setPatientSearch(true);
            setAlertVisible(false);
            ServerRequestProtected(API_URL + "/FindPatientPay", 'post', {
                "TABLENAME": enumUtil.enumAPITableName.CollectCopay,
                "SEARCHCRITERIA": {
                    "PatientID": PatientID + "",
                }
            }).then((response) => {
                setIsLoading(false);
                setPatientSearch(false);
                let updatedClaimInsuranceData = response;
                let saveModal = { ...saveAppointmentModal }
                let mainModal = { ...mainAppointmentModal }
                let modal = { ...patientDetails }
                let data = { ...updatedClaimInsuranceData }
                if (Object.keys(data).length > 0) {
                    mainModal['PatientID'] = PatientID + '';
                    saveModal['PatientID'] = PatientID + '';
                    if (isNull(Appointment_Modal.ProviderID) && !isNull(data['ProviderID'])) {
                        // mainModal['ProviderID'] = data['Providers'] + "";
                        let ProviderData = DropDowns?.Provider?.find(
                            item => String(item.value) === String(data.ProviderID)
                        );
                        mainModal['ProviderID'] = ProviderData?.display || ""
                        saveModal['ProviderID'] = data['ProviderID'] + "";
                        if (ProviderData.DoxyStatusURL === 'Active' && !isNull(ProviderData.DoxyURL) && IsTelehealthEnabled) {
                            setIsTeleHealth(true)
                        } else {
                            setIsTeleHealth(false)
                        }
                        setProvID(data['ProviderID'] + "");
                        handleDuration(data['ProviderID']);
                        // handleAppointmentTypeDD(data.ProviderID)
                        let appointmentTypeDD = handleAppointmentTypeDD(data.ProviderID + "")

                        // let appointmentTypeDD = []
                        // let selectedProvider = providersList?.find((item) => item.value + "" === data.ProviderID + "");
                        // if (!isNull(selectedProvider) && selectedProvider.IsStaff && selectedProvider.EnableScheduling) {
                        //     appointmentTypeDD = makeMultiSelectArray(dropDownReducer.AppointmentType, selectedProvider?.AllowAppointmentType)
                        //     setVisitTypeList(appointmentTypeDD);
                        // } else {
                        //     setVisitTypeList(dropDownReducer.AppointmentType)
                        // }
                        if (appointmentTypeDD.length === 1) {
                            mainModal['AppointmentTypeID'] = appointmentTypeDD[0].display
                            saveModal['AppointmentTypeID'] = appointmentTypeDD[0].value + ""
                            mainModal["AppointmentType"] = appointmentTypeDD[0]?.display;
                            const duration = appointmentTypeDD[0]?.Duration;
                            getProceduresByAppointmentType(appointmentTypeDD[0].value)
                            if (!isNull(duration)) {
                                mainModal["DurationID"] = duration;
                                saveModal["DurationID"] = duration;
                            }
                            if (!isNull(mainAppointmentModal.AppointmentStart) && !isNull(duration)) {
                                // modal["DurationID"] = duration;
                                const endTimes = timeParser(mainAppointmentModal.AppointmentStart, duration);
                                mainModal["AppointmentEnd"] = endTimes;
                                saveModal["AppointmentEnd"] = endTimes;
                                handleTimeSlots(saveModal);
                            }
                        } else {
                            mainModal['AppointmentTypeID'] = ''
                            saveModal['AppointmentTypeID'] = ''
                            mainModal["AppointmentType"] = ''
                        }
                        if (AppoimentModeDD.length === 2) {
                            mainModal['AppointmentMode'] = AppoimentModeDD[1].display
                            saveModal['AppointmentMode'] = AppoimentModeDD[1].value + ""
                        } else {
                            mainModal['AppointmentMode'] = ''
                            saveModal['AppointmentMode'] = ''
                        }
                    }
                    if (isNull(data['LocationID'])) {
                        if (locationList && locationList.length === 2) {
                            mainModal['LocationID'] = locationList[1].display + "";
                            mainModal['LocationName'] = locationList[1].display + "";
                            saveModal['LocationID'] = locationList[1].value + "";
                            setLocID(locationList[1].value + "");
                        }
                    } else {
                        mainModal['LocationID'] = data['LocationName'] + "";
                        mainModal['LocationName'] = data['LocationName'] + "";
                        saveModal['LocationID'] = data['LocationID'] + "";
                        setLocID(data['LocationID'] + "");
                    }
                    if (!isNull(data['InsuranceID'])) {
                        mainModal['InsuranceID'] = data['InsuranceName'] + "";
                        mainModal['InsuranceName'] = data['InsuranceName'] + "";
                        saveModal['InsuranceID'] = data['InsuranceID'] + "";
                    } else {
                        mainModal['InsuranceID'] = "";
                        mainModal['InsuranceName'] = "";
                        saveModal['InsuranceID'] = null;
                    }
                    if (!isNull(data['Copay'])) {
                        saveModal['Copay'] = data['Copay'] + "";
                    }
                    for (let property in modal) {
                        modal[property] = data[property] + ""
                    }
                    setPatientModal(true);
                }
                setIs(true)
                // setSaveAppointmentModal(saveModal);
                setPatientDetails(response);
                setGender(response?.Gender)

                // setMainAppointmentModal(mainModal);
                getAvailableSlotsByParam(saveModal.ProviderID, saveModal.LocationID, mainModal?.AppointmentDate, mainModal, saveModal);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
                setMainAppointmentModal(Appointment_Modal);
                setPatientDetails(Patient_Modal);
                setPatientModal(false);
            })
        }
    }
    const getInitials = (name) => {
        const nameArray = name.split(' ');
        if (nameArray.length >= 2) {
            return nameArray[1][0] + nameArray[0][0];
        } else if (nameArray.length === 1) {
            return nameArray[0][0];
        }
        return '';
    };
    const userInitials = getInitials(patientDetails?.PatientName)
    const getTime12to24hrs = (time12Hrs) => {
        const [time, period] = time12Hrs.split(' ');
        const [hours, minutes] = time.split(":");
        const hours24 = period === 'AM' ? hours % 12 : (parseInt(hours, 10) % 12) + 12;
        const time24hrs = hours24.toString().padStart(2, '0') + ":" + minutes + ":" + "00";
        return time24hrs;

    }


    //console.log(userInitials, 'userInitials');

    //////////////////////////////////
    const handleTimeSlots = (modal, value) => {
        let calendarSlotStart = modal?.AppointmentStartTime?.split(' ')[4];
        let calendarSlotEnd = modal?.AppointmentEndTime?.split(' ')[4];
        let appointmentStart = getTime12to24hrs(value ? value : modal.AppointmentStart);
        let appointmentEnd = modal?.AppointmentEnd;
        let appointmentDate = modal?.AppointmentDate;
        let calendarDateObject = new Date(modal?.AppointmentStartTime)
        let year = calendarDateObject?.getFullYear();
        let month = calendarDateObject?.getMonth() + 1;
        let day = calendarDateObject?.getDate();
        let calendarDate = month + "/" + day + "/" + year;
        if (calendarDate != appointmentDate || appointmentStart != calendarSlotStart || appointmentEnd != calendarSlotEnd) {
            const [month, day, year] = appointmentDate.split('/');
            const [hrs, mints, scnds] = appointmentStart.split(':');
            const [hours, minutes, seconds] = appointmentEnd.split(':');
            calendarSlotStart = new Date(year, month - 1, day, hrs, mints, scnds);
            calendarSlotEnd = new Date(year, month - 1, day, hours, minutes, seconds);
            modal['AppointmentStartTime'] = calendarSlotStart + "";
            modal['AppointmentEndTime'] = calendarSlotEnd + "";

        } else {
            return
        }
    }
    /////////////////////////////////
    const handleAppointment = (type, cptData) => {
        let saveModal;
        let validation;
        if (type === "appointment") {
            appointmentFormValidtion()
            validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        }
        if (type === 'block') {
            BlockFormValidation();
            validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        }
        if (validation) {
            return
        } else {

            if (type === "appointment") {
                let patientData = []
                allPatientDetails.map((item) => {
                    patientData.push({
                        PatientID: item.PatientID + "",
                        AppointmentStatus: item.AppointmentStatus + "",
                        Email: item.Email,
                        PatientAppointmentID: item.PatientAppointmentID ? item.PatientAppointmentID + "" : ''
                    })
                })

                let ApptID = (mainAppointmentModal?.PatientAppointmentID || 0).toString();
                saveModal = {
                    TableName: enumUtil.enumAPITableName.PatientAppointment,
                    ID: ApptID,
                    DATA: {
                        ...saveAppointmentModal,
                        ...(ApptID == 0 ? { AppointmentStatus: 'Scheduled', AppointmentStatusID: '1' } : {}),
                        IsGroupAppointment: selectedType === 'Group' ? 'true' : 'false',
                        GroupIdentifier: mainAppointmentModal.GroupIdentifier ? mainAppointmentModal.GroupIdentifier : ''
                    },
                    ListofData: patientData,
                    Main: ProcedureCodeData && ProcedureCodeData?.length > 0 ? ProcedureCodeData : []
                }
            }
            if (type === 'block') {
                const data = { ...saveBlockAppointmentModal }
                const appointmentObj = handleAppointmentTime(data, mainBlockAppointmentModal?.ProviderID, mainBlockAppointmentModal?.AllDay);
                appointmentObj.ProviderID =
                    saveModal = {
                        TableName: enumUtil.enumAPITableName.PatientAppointment,
                        ID: appointmentID,
                        DATA: { ...appointmentObj }
                    }
            }
            setIsLoading(true);
            ServerRequestProtected(API_URL + '/SavePatientAppointment', "post", saveModal)
                .then((response) => {
                    setIsLoading(false);
                    if (!isNull(response)) {
                        props?.setIsRecordSaved && props.setIsRecordSaved(true);
                        NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success);
                        setIsRefresh(true);
                        dispatch(ReloadGridAction({ AppointmentListEncounter: true }));
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    if (type === 'block' && (error?.response?.data === "Appointment Already Booked." || error?.response?.data === "The Selected Time Is Break")) {
                        handleBlockConfirmation();
                    } else {
                        NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
                    }
                })
        }
    }
    const handleOnBlockClose = () => {
        handleOnClose();
        if (isRefresh && getAppointments) {
            getAppointments();
        }
        setMainBlockAppointmentModal(Block_Modal);
        setSaveBlockAppointmentModal({});
        setBlockAppointmentValidation(BlockValidation_Modal);
        if (setIsBlocked) {
            setIsBlocked(false);
        }
    }
    const handleAppointmentClose = () => {
        if (isRefresh && getAppointments) {
            getAppointments();
        }
        if (!isNull(responseByID)) {
            setSlotDate(dateFromCalendar);
            setResponseByID(null);
        }
        setMainAppointmentModal({ ...Appointment_Modal, AppointmentDate: dateFromCalendar, IsBlocked: 0 + "" });
        setSaveAppointmentModal({ ...saveAppointmentModal, AppointmentDate: dateFromCalendar, IsBlocked: 0 + "" });

        if (isRefresh && handleOnCloseSave) {
            handleOnCloseSave()
        } else {
            handleOnClose();
        }
        setAppointmentValidation(validationModal);
        setPatientName("");
        setPatientModal(false);
        setIsRefresh(false);
        if (setIsBlocked) {
            setIsBlocked(false);
        }
    }
    const handleLocationChange = () => {
        setIsLocationUpdate(!isLocationUpdate);
    }
    const handleCopayChange = () => {
        setIsCopayUpdate(!IsCopayUpdate);
    }
    const handleActiveTab = (item) => {
        setActiveTab(item)
    }
    const getProviderScheduler = (value, type) => {
        let scheduler;
        let modal = {
            providerID: String(provID),
            locationID: String(locID),
            Date: slotDate,
        }
        const provider = modal["providerID"];
        if (!isNull(provID) && !isNull(locID) && !isNull(slotDate)) {
            setProviderScheduler((prev) => {
                let updatedValue = { ...prev, [provider]: [] }
                return updatedValue;
            })
            setIsLoading(true);
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Scheduler,
                SearchCriteria: { ...modal },
            }
            ServerRequestProtected(API_URi + "/ProvidersSchedules", "post", saveModal).then((response) => {
                setIsLoading(false);
                scheduler = response.filter((schedule) => {
                    return (schedule.ProviderID == provider);
                })
                setProviderScheduler((prev) => {
                    let updatedValue = { ...prev, [provider]: scheduler }
                    handleDuration(updatedValue[provider], type = 'durationClaim');
                    return updatedValue;
                })
                setMainBlockAppointmentModal((prev) => {
                    return { ...prev, ProviderSchedulerStartTime: scheduler[0]?.TimeTo, ProviderSchedulerEndTime: scheduler[0]?.TimeFrom }
                })
            }).catch((error) => {
                setIsLoading(false);
            })
        }
    }
    const handleSearchList = () => {
        setPatientModal(false);
        setPatientName('');
    }
    ///// AddNeWPatient Popup //////////////////
    const [isOpenPatient, setIsOpenPatient] = useState(false)
    const handleOpenPatient = () => {
        setIsOpenPatient(true)
    }
    const handleClosePatient = () => {
        setIsOpenPatient(false)
    }
    let AddPAtPopup = ''
    if (isOpenPatient) {
        AddPAtPopup = <AddNewPat isOpenPatient={isOpenPatient} onClose={handleClosePatient} />
    }
    /////////////deletePopUp/////////////
    const handleModals = () => {
        handleOnClose();
        getAppointments();
    }
    const handleDeleteModal = () => {
        if (IsDeleteAllowed) {
            setIsOpenAlert(true)
        }
    }
    const onCloseDelete = () => {
        setIsOpenAlert(false)
    }
    let deleteConfirmation = ""
    if (isOpenAlert) {
        if (mainAppointmentModal.IsGroupAppointment) {
            deleteConfirmation = <DeleteGroupAppointment isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.PatientAppointment} ID={mainAppointmentModal.GroupIdentifier} onClose={handleModals} />
        } else {
            deleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URi} TableName={enumUtil.enumAPITableName.PatientAppointment} ID={appointmentID} onClose={handleModals} />
        }
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }

    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={appointmentID + ""} TableName={enumUtil.enumAPITableName.PatientAppointment} />
    }
    const handleIntakePreview = (templateID, intakeID, PatientID, FormStatus) => {
        setEHRTemplateID(templateID);
        setIntakeFormID(intakeID);
        setPatientID(PatientID);
        setIntakeFormStatus(FormStatus);
        setIsOpenIntakePreview(true);
    }
    const onClose = () => {
        setIsOpenIntakePreview(false);
    }
    const onCloseSave = () => {
        setIsOpenIntakePreview(false);
        FindByID();
    }

    let IntakePreviewPopup = ""
    if (IsOpenIntakePreview) {
        IntakePreviewPopup = <IntakePreview isOpenPopup={IsOpenIntakePreview} onClose={onClose} onCloseSave={onCloseSave} ID={EHRTemplateID} intakeFormID={IntakeFormID} handleIntakeStatus={handleIntakeStatus} rejectionConfirmation={handleRejectedConfimation} PatientID={Patientid} FormStatus={IntakeFormStatus} />
    }
    const handleMarkAsNoShowPopup = (status) => {
        setSelectedStatus(status);
        setIsMarkAsNoShowOpen(true);
    }
    const onCloseMarkAsNoShowPopup = (dynamicKey) => {
        setIsMarkAsNoShowOpen(false);
        let modal = { ...mainAppointmentModal }
        const { [dynamicKey]: _, Reason, ...saveModal } = saveAppointmentModal;
        modal['AppointmentStatus'] = previousStatus?.StatusName;
        modal['AppointmentStatusID'] = previousStatus?.StatusName + "";
        saveModal['AppointmentStatus'] = previousStatus?.StatusName;
        saveModal['AppointmentStatusID'] = previousStatus?.StatusID + "";
        setMainAppointmentModal(modal);
        setSaveAppointmentModal(saveModal);
    }
    const onCloseSaveMarkAsNoShowPopup = () => {
        setIsMarkAsNoShowOpen(false);
    }
    let MarkNoShowPopup = ""
    if (IsMarkAsNoShowOpen) {
        MarkNoShowPopup = <MarkAsNoShowPopup isOpenPopup={IsMarkAsNoShowOpen} onClose={onCloseMarkAsNoShowPopup} onCloseSave={onCloseSaveMarkAsNoShowPopup} Status={selectedStatus} searchParam={saveAppointmentModal} setSearchParam={setSaveAppointmentModal} modal={mainAppointmentModal} handleSave={() => { onCloseSaveMarkAsNoShowPopup(); setPreviousStatus({ StatusName: mainAppointmentModal?.AppointmentStatus, StatusID: mainAppointmentModal?.AppointmentStatusID }) }} />
    }
    const handleRecurringPopup = (e) => {
        const { name, value, checked } = e.target;
        appointmentFormValidtion();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);

        if (name === "Recurring") {
            if (validation) {
                NotificationHandler("Fill all required fields", enumUtil.enumtoaster.error);
                return;
            }
            setIsRepeats(true);
            setIsSingular(false);
            if (checked) {
                setIsRecurringPopupOpen(true);
            }
        } else {
            setIsRepeats(false);
            setIsSingular(true);
        }
    }
    const onRecurringClose = () => {
        setIsRepeats(false);
        setIsSingular(true);
        setIsRecurringPopupOpen(false);
    }
    const OnSaveRecurringClose = () => {
        setIsRepeats(false);
        setIsRecurringPopupOpen(false);
        handleOnClose();
    }
    let RecurringApptPopup = "";
    if (isRecurringPopupOpen) {
        RecurringApptPopup = <RecurringPopup openPopup={isRecurringPopupOpen} onClose={onRecurringClose} onCloseSave={OnSaveRecurringClose} ID={''} mainApptModal={mainAppointmentModal} saveApptModal={saveAppointmentModal} ProID={provID} LocID={locID} />
    }
    const handleOnClickSearch = () => {
        setisOpenPatSearch(true)
    }
    const onClosePatSearch = () => {
        setisOpenPatSearch(false)
        setSelectedRows(new Set())
    }
    const onRowSelection = (listOfIds) => {
        const arrayOfIds = Array.from(listOfIds); // Convert the Set to an array
        const lastSelectedId = arrayOfIds[arrayOfIds.length - 1]; // Get the last element in the array
        setSelectedRows(new Set([lastSelectedId])); // Set the last selected ID as a new Set
        setSelectedClaimID(lastSelectedId);
    }
    const rowKeyGetter = (row) => {
        return row.PatientID;
    }
    const handleSelectPatient = (patientData) => {
        let arr = [...patientData]
        let data = arr.filter((item) => {
            return item.PatientID + "" === selectedClaimId + ""
        })[0]
        handleSelectedData(data, 'PatientID', 'server')
        onClosePatSearch()
    }
    let PatientSearchPopup = ''
    if (isOpenPatSearch) {
        PatientSearchPopup = <PatientSearch isOpenPatSearch={isOpenPatSearch} onClosePatSearch={onClosePatSearch} handleSelectPatient={handleSelectPatient} onRowSelection={onRowSelection} rowKeyGetter={rowKeyGetter} selectedRows={selectedRows} />
    }
    const handleCreateAlert = () => {
        setAlertVisible(true);
    };
    let Alert = ""
    if (isAlertVisible && !isNull(patientDetails?.PatientID)) {
        Alert = <ActiveAlert alertFrom={'Patient'} ID={patientDetails?.PatientID + ""} display={`Patient ${patientDetails?.PatientName}`} />
    }
    const handleBlockConfirmation = () => {
        setIsBlockConfirmation(true);
    }
    const onCloseBlockConfirmation = () => {
        setIsBlockConfirmation(false);
    }
    const onSaveBlockConfirmation = () => {
        const data = { ...saveBlockAppointmentModal }
        const appointmentObj = handleAppointmentTime(data, mainBlockAppointmentModal?.ProviderID, mainBlockAppointmentModal?.AllDay);
        let saveModal = {
            TableName: enumUtil.enumAPITableName.PatientAppointment,
            ID: appointmentID,
            DATA: { ...appointmentObj, "IsCancel": "1" }
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/SavePatientAppointment', "post", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (!isNull(response)) {
                    props?.setIsRecordSaved && props.setIsRecordSaved(true);
                    NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success);
                    setIsBlockConfirmation(false);
                    setIsRefresh(true);
                }
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            })
    }
    let BlockConfirmationPopup = "";
    if (IsBlockConfirmation) {
        BlockConfirmationPopup = <BlockConfirmation isOpenPopup={IsBlockConfirmation} onClose={onCloseBlockConfirmation} onCloseSave={onSaveBlockConfirmation} isLoading={isLoading} />
    }
    const closeDropdown = () => {
        setFilterstatus(false)
        setShowContextMenu(false);
    };
    const handleToggleOption = (option, name) => {
        let data = [];
        let modal = { ...saveAppointmentModal }
        const isSelected = IntakeValue.some((selected) => selected.value == option.value);
        if (isSelected) {
            data = IntakeValue.filter((selected) => selected.value != option.value);
            let dataValue = data?.map((item) => item.value).join(", ");
            if (name) modal[name] = dataValue
            setIntakeValue(data)
        } else {
            data = [...IntakeValue, option]
            let dataValue = data?.map((item) => item.value).join(", ");
            if (name) modal[name] = dataValue;
            setIntakeValue(data);
        }
        setReloadSuperSearch(!reloadSuperSearch)
        setSaveAppointmentModal(modal);
    };
    const compareDateToCurrentDate = (dateToCompare) => {
        const format = 'MM/dd/yyyy';
        const date = dateToCompare;
        const inputDate = parse(date, format, new Date());
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (isAfter(inputDate, today)) {
            setAppointmentIsInFuture(true);
        } else if (isBefore(inputDate, today)) {
            setAppointmentIsInFuture(false);
        } else if (isEqual(inputDate, today)) {
            setAppointmentIsInFuture(false);
        }

        return isAfter(inputDate, today)
    }
    const getStatusDropDowns = (StatusName, statusID) => {
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.AppointmentStatus,
        }
        setFilteredStatusArray([]);
        ServerRequestProtected(API_URL + '/AppointmentStatusDropDown', 'post', saveModal)
            .then((response) => {
                let filteredStatusArray = response.filter((status) => { return status.Status === StatusName });
                let nextStatusArray = filteredStatusArray.length > 0 ? filteredStatusArray[0]?.NextStatus : [];
                setStatusArray(response);
                setFilteredStatusArray(nextStatusArray);
            }).catch((error) => {
                setFilteredStatusArray([]);
                setStatusArray([]);
            })
    }
    const handleResendIntakeForm = (ID) => {
        let saveModal = {
            "ID": ID + ""
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/ResendIntakeForm', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
            })
    }
    useEffect(() => {
        let StatusName = mainAppointmentModal['AppointmentStatus'];
        let filteredStatusArray = StatusArray.filter((status) => { return status.Status === StatusName });
        let nextStatusArray = filteredStatusArray.length > 0 ? filteredStatusArray[0]?.NextStatus : [];
        setFilteredStatusArray(nextStatusArray);
    }, [mainAppointmentModal['AppointmentStatus']])
    useEffect(() => {
        // if object is empty dont go inside 
        if (providerScheduler && Object.keys(providerScheduler).length > 0) {
            if (!isNull(provID) && !isNull(locID) && !isNull(slotDate)) {
                getAvailableSlots(false);
            }
        }
    }, [providerScheduler])
    useEffect(() => {
        const prev = prevFilterRef.current;
        const isInitialRender = prev.isRefresh === false
        const hasChanged = JSON.stringify(isRefresh) !== JSON.stringify(prev.isRefresh)
        if (isInitialRender) {
            //console.log('isInitialRender', isInitialRender);
            // getProviderScheduler()
        } else if (hasChanged) {
            //console.log('hasChanged', hasChanged);
            getAvailableSlots()
            getProviderScheduler()
        }
        prevFilterRef.current = {
            isRefresh,
        };
    }, [isRefresh])
    useEffect(() => {
        if (!isNull(responseByID)) {
            handleCreateAlert();
            setMainAppointmentModal((prev) => ({ ...prev, ...responseByID, AppointmentStart: responseByID?.AppointmentStart_12H }));
            setSaveAppointmentModal(() => ({ AppointmentMode: responseByID?.AppointmentMode, AppointmentStart: responseByID?.AppointmentStart, AppointmentStartTime: responseByID?.AppointmentStartTime, AppointmentEnd: responseByID?.AppointmentEnd, AppointmentEndTime: responseByID?.AppointmentEndTime, AppointmentDate: responseByID?.AppointmentDate }))
            setPreviousStatus({ StatusName: responseByID?.AppointmentStatus, StatusID: responseByID?.AppointmentStatusID })
            setPatientDetails({ ...patientDetails, ...responseByID })
            setMainBlockAppointmentModal((prev) => ({
                ...prev,
                ...responseByID,
                LocationID: responseByID.LocationName,
                ProviderID: responseByID.ProviderName,
            }));
            setSaveBlockAppointmentModal(() => ({
                AppointmentStart: responseByID?.AppointmentStart,
                AppointmentStartTime: responseByID?.AppointmentStartTime,
                AppointmentEnd: responseByID?.AppointmentEnd,
                AppointmentEndTime: responseByID?.AppointmentEndTime,
                AppointmentDate: responseByID?.AppointmentDate,
                LocationID: responseByID?.LocID + "",
                ProviderID: responseByID?.ProID + "",
                Reason: responseByID?.Reason,
            }))
            setIntakeValue(responseByID?.IntakeForm || []);
            // if (!isBlocked) FindPatientInsurances(responseByID?.PatientID);
            setPatientModal(true);
            setPatientSearch(false);
            setLocID(!isNull(responseByID?.LocID) ? responseByID?.LocID + "" : "");
            setProvID(!isNull(responseByID?.ProID) ? responseByID?.ProID + "" : "");
            setSlotDate(!isNull(responseByID?.AppointmentDate) ? responseByID?.AppointmentDate + "" : "")
            setReloadSuperSearch((prev) => !prev);
            // getStatusDropDowns(responseByID?.AppointmentStatus, responseByID?.AppointmentStatusID);
            compareDateToCurrentDate(responseByID?.AppointmentDate);
        }
    }, [responseByID])
    useEffect(() => {
        let filteredArray = filteredAvailableSlots?.filter((item) => !isNull(item?.StartTime))
        let chunkedData = [];
        let resultArray = [];
        for (let i = 0; i < filteredArray.length; i += 4) {
            chunkedData.push(filteredArray?.slice(i, i + 4));
        }
        for (let i = 0; i < chunkedData.length; i += 12) {
            resultArray.push(chunkedData?.slice(i, i + 12))
        }
        setChunkedArray(resultArray);
    }, [filteredAvailableSlots])
    const mainBodyRef = useRef(null);
    const [CalenderHeight, setCalenderHeight] = useState(0);
    useEffect(() => {
        setCalenderHeight(mainBodyRef.current?.clientHeight);
    }, [saveAppointmentModal]);
    useEffect(() => {
        if (isRefresh) {
            handleAppointmentClose();
        }
        // getIntakeDD();
    }, [isRefresh]);
    useEffect(() => {
        if (availableStartTimeSlots?.length > 0) {
            if (SlotSchedule === "Scheduled") {
                let filteredArray = availableStartTimeSlots.filter((slot) => slot?.InScheduled == 1)
                let notScheduledFilteredArray = filteredArray.filter((item) => item.IsScheduled == 0);
                setfilteredAvailableSlots(filteredArray);
                setNotScheduledFilteredSlots(notScheduledFilteredArray);
            }
            else if (SlotSchedule === "All") {
                let filteredArray = [...availableStartTimeSlots]

                setfilteredAvailableSlots(filteredArray)
            }
            setCounter(0);
        } else if (!isNull(responseByID) && availableStartTimeSlots?.length === 0 && IsSlotAvailable) {
            setfilteredAvailableSlots([]);
            setSaveAppointmentModal((prev) => {
                return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
            })
            setMainAppointmentModal((prev) => {
                return { ...prev, AppointmentStart: "", AppointmentEnd: "", }
            })
        }
    }, [SlotSchedule, availableStartTimeSlots]);
    useEffect(() => {
        if (saveAppointmentModal['EHRTemplate']) {
            let templateArray = String(saveAppointmentModal['EHRTemplate']).split(', ');
            let filteredData = IntakeValue?.filter((item) => {
                return templateArray.some((id) => {
                    return id == item.value
                });
            })
            setIntakeValue(filteredData);
        } else {
            setIntakeValue([]);
        }
    }, [saveAppointmentModal['EHRTemplate']])
    useEffect(() => {
        handleCreateAlert();
    }, [patientDetails])

    // View or Create Encounter
    let state = useSelector(state => state.SidebarList)
    const handleActive_SubTab = (key, name, component, right) => {
        let arr = state
        let dynamicTabs = [...arr]
        const newTabObject = {
            key: key,
            name: name,
            component: component,
            right: right,
            time: new Date(),
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            dispatch(MainTabContentTabList(dynamicTabs));
        }
        dispatch(MainTabContentActiveTab(key))
        // setOpenTab && setOpenTab('')
    }
    const handleOpenEncounter = (encounter, type) => {
        if (type !== "New Encounter" && type !== "New AI Encounter") {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj = {
                active: true,
                key: 2,
                name: "Encounter Menu",
                data: {
                    name: `${encounter.FirstName} - ${encounter.EncounterDate}`,
                    id: encounter.EncounterID + "",
                    patid: encounter.PatientID,
                    // patID: PatientIDR,
                    type: encounter.NoteType,
                    time: new Date()
                },
            }
            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj))
            }, 0);
        } else {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj = {
                active: true,
                key: 2,
                name: "EncounterMenu",
                data: {
                    name: "All Encounters",
                    id: 0,
                    component: <EncounterMenuSearch />,
                    setRecordsNum: null,
                    openedFor: type,
                    EncounterPopup: {
                        PatientName: encounter.FirstName,
                        EncounterDate: encounter?.AppointmentDate,
                        SeenBy: encounter?.ProID + "",
                        Facility: encounter?.LocID + "",
                        PatientID: encounter.PatientID + "",
                        PatientAppointmentID: encounter?.PatientAppointmentID + "",
                        EncounterType: encounter?.EncounterTypeID + "",
                        NoteType: encounter?.NoteType + "",
                        EHRTemplateID: encounter?.EHRTemplateID + "",
                        IsSystemGenerated: encounter?.IsSystemGenerated + "",
                        IsGroupAppointment: encounter.IsGroupAppointment ? 'True' : false,
                        GroupIdentifier: encounter.GroupIdentifier
                    }
                },
            }
            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj))

            }, 0);
        }
        handleOnClose()
    }
    const handleOpenEncounterGroup = (patient, encounter, type) => {
        if (patient.AppointmentStatus === '7' || patient.AppointmentStatus === '8') {
            return
        }
        if (type === 'Group') {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj1 = {
                active: true,
                key: 2,
                name: "Encounter Menu",
                data: {
                    name: `Group Encounter - ${encounter.EncounterDate ? encounter.EncounterDate : encounter.GroupEncounterDate}`,
                    id: encounter.GroupIdentifier,
                    patid: encounter.PatientID + "",
                    type: encounter.NoteType,
                    time: new Date(),
                    groupEncounter: {
                        isGroupEncounter: type === 'Group' ? 'true' : '',
                        GroupIdentifier: type === 'Group' ? encounter.GroupIdentifier : '',
                        showGroupNote: type === 'Group' ? true : false
                    }
                },
            }
            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj1))
            }, 0);
        } else {
            handleActive_SubTab(9, 'Encounters', <EncounterMenu />, true)
            let obj = {
                active: true,
                key: 2,
                name: "Encounter Menu",
                data: {
                    name: `${patient.FirstName} - ${encounter.EncounterDate ? encounter.EncounterDate : encounter.GroupEncounterDate}`,
                    id: patient.EncounterID + "",
                    patid: patient.value + "",
                    type: patient.NoteType,
                    time: new Date(),
                    groupEncounter: {
                        isGroupEncounter: 'true',
                        GroupIdentifier: encounter.GroupIdentifier ? encounter.GroupIdentifier : '',
                        showGroupNote: false
                    }
                },
            }
            setTimeout(() => {
                dispatch(TabActionEncounterMenu(obj))
            }, 0);
        }
        handleOnClose()

    }
    const handleShowContextMenu = (e) => {
        e.stopPropagation();
        setShowContextMenu(true);
    };
    const showAddEncounter = mainAppointmentModal.IsGroupAppointment ? allPatientDetails.some(item => item.AppointmentStatus !== '7' && item.AppointmentStatus !== '8') : true
    const patients = patientDetails?.PatientList || [];
    return (
        <div>
            {deleteConfirmation}
            {AddPAtPopup}
            {PatientSearchPopup}
            {ConfirmStatusChangePopup}
            <Modal show={showEvents} onHide={showEvents} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 add_new_appointment">
                {AuditPopup}
                {IntakePreviewPopup}
                {MarkNoShowPopup}
                {RecurringApptPopup}
                {RejectionConfirmation}
                {BlockConfirmationPopup}
                {Alert}
                {isLoading ? <Loader /> : <></>}
                <Modal.Body>
                    <SearchHeader masterListButton={showEvents} />
                    <ModalHeader HeaderName={masterHeader} DeletePopup={DeletePopup} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} isClosed={() => handleAppointmentClose()} key={631} Name={'Appointment'} IsDeleteAllowed={IsDeleteAllowed} />
                    <Tab.Container defaultActiveKey={isBlocked ? 'blockTime' : "patientAppointment"}>
                        <div className="hk-schedulerModal">
                            <div ref={mainBodyRef} className="hk-schedulerModal__main">
                                <div className="content mx-10">
                                    <div className="d-flex align-items-center">
                                        <Nav variant="tabs" className='card-tabss'>
                                            {[0, "0", null].includes(AppointmentID) ?
                                                <>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="patientAppointment" onClick={() => setSaveAppointmentModal({ ...saveAppointmentModal, IsBlocked: 0 + "" })}><span className="heading me-1 " >Patient Appointment</span></Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="ProcedureCodes"><span className="heading ms-3" >Procedure Codes</span></Nav.Link>
                                                    </Nav.Item>
                                                </>
                                                :
                                                isBlocked ?
                                                    <>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="blockTime" onClick={() => setSaveAppointmentModal({ ...saveAppointmentModal, IsBlocked: 1 + "" })}><span className="heading ms-3" >Block Time </span></Nav.Link>
                                                        </Nav.Item>
                                                    </>
                                                    :
                                                    <>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="patientAppointment" onClick={() => setSaveAppointmentModal({ ...saveAppointmentModal, IsBlocked: 0 + "" })}><span className="heading me-1 " >Patient Appointment</span></Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="ProcedureCodes"><span className="heading ms-3" >Procedure Codes</span></Nav.Link>
                                                        </Nav.Item>
                                                    </>
                                            }
                                        </Nav>
                                    </div>
                                    <div className="content__btns d-flex align-items-center gap-1">
                                        {isBlocked ? null :
                                            <div className='d-flex align-items-center cursor-pointer'>
                                                {!isNull(mainAppointmentModal?.EncounterID) || !isNull(mainAppointmentModal.GroupEncounterID) ?
                                                    <>
                                                        {patientDetails?.IsGroupAppointment && !isNull(mainAppointmentModal.GroupEncounterID) ?
                                                            <div className="position-relative za-appointment_popup group-View-encounter">
                                                                <div className={`d-flex align-items-center cursor-pointer`}
                                                                // onClick={() => handleOpenEncounter(patientDetails)}
                                                                >
                                                                    <p className='heading fs-11 validate-color' >View Encounter</p>
                                                                    <i className='icon-enrollment fs-13 lh-9'></i>
                                                                </div>
                                                                <div className="appointment-card Processing pb-10" >
                                                                    <div className="d-flex justify-content-between align-items-center za-br-clr br-bottom-1 pb-1 px-2px mb-2 cursor-pointer" onClick={() => handleOpenEncounterGroup('', mainAppointmentModal, 'Group')}>
                                                                        <div className="d-flex align-items-center gap-1" >
                                                                            <i className="icon-group-pateint fs-13"></i>
                                                                            <div className="">
                                                                                <p className="heading ar-dark-color fs-11">View Group Encounter</p>
                                                                                <p className="text ar-light-color fs-9">View the group encounter for all participants</p>
                                                                            </div>
                                                                        </div>
                                                                        <i class="icon-right-direction fs-11 ar-light-color"></i>
                                                                    </div>


                                                                    <div className="d-flex flex-column gap-1">
                                                                        <p className="text fs-10 ar-light-color">Individual Encounters</p>

                                                                        <div className="d-flex flex-column gap-1">
                                                                            {patients.map((patient, index) => (
                                                                                <div className={`d-flex justify-content-between align-items-center p-2px za-br-clr br-bottom-1 cursor-pointer ${patient.AppointmentStatus === '7' || patient.AppointmentStatus === '8' ? 'disabled' : ''}`}
                                                                                    key={index}
                                                                                    onClick={() => handleOpenEncounterGroup(patient, mainAppointmentModal)}
                                                                                >
                                                                                    <p className="text fs-10 ar-light-color" >
                                                                                        <span className="font-m ar-dark-color">{patient.PatientName}</span>{" "}
                                                                                        ({patient.Age}){"  "} {patient.Gender === "Male" ? "M" : "F"}
                                                                                    </p>
                                                                                    <i class="icon-right-direction fs-11 ar-light-color"></i>
                                                                                </div>

                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : !isNull(mainAppointmentModal?.EncounterID) ?
                                                                <div className={`d-flex align-items-center cursor-pointer`} onClick={() => handleOpenEncounter(patientDetails)}>
                                                                    <p className='heading fs-11 validate-color' >View Encounter</p>
                                                                    <i className='icon-enrollment fs-13 lh-9'></i>
                                                                </div> : null
                                                        }
                                                    </>
                                                    : isNull(patientDetails?.EncounterID) && !isNull(appointmentID) &&
                                                        showAddEncounter &&
                                                        (!mainAppointmentModal.IsGroupAppointment ||
                                                            (
                                                                mainAppointmentModal.GroupStatusDisplay !== 'Seen' &&
                                                                mainAppointmentModal.GroupStatusDisplay !== 'Cancelled' &&
                                                                mainAppointmentModal.GroupStatusDisplay !== 'No Show'
                                                            )
                                                        ) &&

                                                        (mainAppointmentModal.IsGroupAppointment ||
                                                            (
                                                                mainAppointmentModal.AppointmentStatus !== 'No Show' &&
                                                                mainAppointmentModal.AppointmentStatus !== 'Cancelled'
                                                            )
                                                        ) &&
                                                        // mainAppointmentModal.GroupStatusDisplay !== 'Seen' &&           // for group appointment 
                                                        // mainAppointmentModal.GroupStatusDisplay !== 'Cancelled' &&      // for group appointment 
                                                        // mainAppointmentModal.GroupStatusDisplay !== 'No Show' &&        // for group appointment    
                                                        // mainAppointmentModal.AppointmentStatus !== 'No Show' &&         // for individual appointment 
                                                        // mainAppointmentModal.AppointmentStatus !== 'Cancelled' &&       // for individual appointment 
                                                        ((!mainAppointmentModal?.AppointmentDate || new Date(mainAppointmentModal?.AppointmentDate) <= new Date())) ?
                                                        // <div className='d-flex align-items-center cursor-pointer' onClick={() => handleOpenEncounter(patientDetails, "New Encounter")}>
                                                        //     <p className={`heading fs-11 validate-color`}>Create Encounter</p>
                                                        //     <i className='icon-enrollment fs-13 lh-9'></i>
                                                        // </div>

                                                        <div className="ar-create-encounter_tooltip">
                                                            {/* <button class={`btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1 ${IsEditAllowed ? "" : 'disable'}`} >
                                                                <span class="fs-16 heading text-white">+</span>New Encounter
                                                                <i className="icon-caret-down br-left-1 lh-25 ps-1-5"></i>
                                                            </button> */}

                                                            <div className='d-flex align-items-center cursor-pointer' onClick={handleShowContextMenu}>
                                                                <p className={`heading fs-11 validate-color`}>Create Encounter</p>
                                                                <i className='icon-enrollment fs-13 lh-9'></i>
                                                            </div>
                                                            <CustomUseRef onClose={closeDropdown} IsActivePtPayments={showContextMenu} type={'menuButton'} className={'position-static'}>
                                                                <div className={`context-menu d-flex flex-column gap-1 left-0 ${showContextMenu && 'Show-context'}`}>
                                                                    <div className="d-flex align-items-center gap-2 px-2" onClick={() => handleOpenEncounter(patientDetails, "New Encounter")}>
                                                                        <i className="icon-plus-feesetup fs-11"></i>
                                                                        <p className='text fs-11 font-m text-nowrap'>Create  Encounter</p>
                                                                    </div>
                                                                    <div className="d-flex align-items-center gap-2 px-2" onClick={() => handleOpenEncounter(patientDetails, "New AI Encounter")}>
                                                                        <i className="icon-ai-encounter fs-14"></i>
                                                                        <p className='text fs-11 font-m text-nowrap'>Create AI Encounter</p>
                                                                    </div>
                                                                </div>
                                                            </CustomUseRef>

                                                        </div>
                                                        : null
                                                }
                                            </div>
                                        }
                                        {mainAppointmentModal.AppointmentStatus === "Ready For Visit" || mainAppointmentModal?.AppointmentStatus === "In Season" ?
                                            <div className="ar-meeting-icon d-flex align-items-center justify-content-center">
                                                <div class="app_tooltip left">
                                                    <i className='icon-Join-meeting fs-12'></i>
                                                    <p className="tool_tip xsm_text text-light">Join Visit</p>
                                                </div>
                                            </div> : null
                                        }
                                    </div>
                                </div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="patientAppointment">
                                        <div className="px-10 pb-2 d-flex flex-column gap-2 ar-inner-scroll">
                                            {[0, "0", null].includes(AppointmentID) && !isOpendFromPatient && EnableGroupAppointments ?
                                                <div className="d-flex align-items-center gap-15">
                                                    <label className="ar_radio-btn d-flex align-items-center gap-6">
                                                        <input
                                                            type="radio"
                                                            id="Claim"
                                                            checked={selectedType === 'Individual'}
                                                            onChange={() => { setSelectedType('Individual') }}
                                                        />
                                                        <p className="text ar-orange-text" htmlFor="Individual">Individual</p>
                                                    </label>
                                                    <label className="ar_radio-btn d-flex align-items-center gap-6">
                                                        <input
                                                            type="radio"
                                                            id="CPT"
                                                            checked={selectedType === 'Group'}
                                                            onChange={() => { setSelectedType('Group') }}
                                                        />
                                                        <p className="text ar-orange-text" htmlFor="Group">Group</p>
                                                    </label>
                                                </div>
                                                : null}
                                            {/* {selectedType === 'Individual' ? */}
                                            <div className='d-flex flex-column gap-2'>
                                                {selectedType === 'Individual' ?
                                                    <>
                                                        {patientModal ? <></> :
                                                            <div className='input claims_info'>
                                                                <div className={`form-group pateint-appointment input flex-row align-items-center ${appointmentValidation.Patient ? 'error' : ''}`}>
                                                                    <i className='icon-Clip-path-group mt-2' onClick={() => handleOnClickSearch()}></i>
                                                                    <SuperSearchList
                                                                        for="Patient"
                                                                        type='server'
                                                                        id='PatientID'
                                                                        name='PatientID'
                                                                        method="post"
                                                                        searchValue={PatientName}
                                                                        ApiLink={API_URl + "/PatientInstantSearch"}
                                                                        postBody={patientBody}
                                                                        onChange={handlePateintChange}
                                                                        getSelectedData={handleSelectedData}
                                                                        is={is}
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        disabled={true}
                                                                        placeholder={'Type 3 or more characters to search...'}
                                                                        icon={false}
                                                                        autocomplete={false}
                                                                        PatientAppt={true}
                                                                        inputError={appointmentValidation.Patient ? true : false}
                                                                    />
                                                                    {appointmentValidation.Patient}

                                                                    <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn ms-1" onClick={handleOpenPatient}>
                                                                        <i className="icon-Group-5719"></i>
                                                                    </button>
                                                                </div>
                                                            </div>}
                                                        {patientSearch ?
                                                            <div className='d-flex justify-content-between ar-copay-img'>
                                                                <div className="d-flex gap-4 py-2">
                                                                    <div className="img-container s-50 circle border-2 ar-bgc-img">
                                                                    </div>
                                                                    <div>
                                                                        <p className="ar-bgc-content m-0" style={{ width: '50%' }}></p>
                                                                        <p className="ar-bgc-content w-30 m-0 mt-2" style={{ width: '55%' }}></p>
                                                                        <p className="ar-bgc-content w-30 m-0 mt-2" style={{ width: '205px' }}></p>
                                                                    </div>
                                                                </div>
                                                                <div className='py-2 me-2 '>
                                                                    <p className="ar-bgc-content-1 w-30 m-0 "></p>
                                                                    <p className="ar-bgc-content-1 mt-2 m-0 ms-auto" style={{ width: '70%' }}></p>
                                                                    <p className="ar-bgc-content-1 w-30 m-0 mt-2 ms-auto" style={{ width: '70%' }}></p>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="client_detail gap-2 d-flex position-relative">
                                                                {patientModal ? <div className='search' onClick={() => handleSearchList()} >
                                                                    <i className='bi bi-search'></i>
                                                                </div> :
                                                                    <div className='search' onClick={() => setPatientModal(true)}>
                                                                        <i className='icon-close fs-7'></i>
                                                                    </div>}
                                                                <div className="client_detail__imgBox">

                                                                    {patientDetails?.ProfilePicture ? (
                                                                        <img
                                                                            src={patientDetails.ProfilePicture}
                                                                            alt="Profile"
                                                                        />
                                                                    ) : (
                                                                        <div className='img-container s-50 circle '>
                                                                            <p
                                                                                className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${gender === 'M'
                                                                                    ? 'za-male'
                                                                                    : gender === 'F'
                                                                                        ? 'za-female'
                                                                                        : 'za-others'
                                                                                    }`}
                                                                            >
                                                                                {userInitials}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="detail hk-details">
                                                                    <div className="hk-details__flex">
                                                                        <div className='d-flex flex-column gap-1'>
                                                                            <p className="heading hk-details__flex__heading fs-13 d-flex gap-1">{patientDetails.PatientName ? patientDetails.PatientName + " " : ""}<p className="text font-m ar-light-color fs-12 ">{patientDetails.DOB ? `(${patientDetails.DOB}) ` : ''}{patientDetails.Age ? `(${patientDetails.Age}) ` : ''}{patientDetails?.Gender ? patientDetails?.Gender : ''}</p></p>

                                                                            <div className="col-md-7">

                                                                                <div className="hk-details__bottom">
                                                                                    {SelfPayPatient ?
                                                                                        <p className="text fs-12 text-nowrap d-flex gap-1 align-items-center  ar-pencil col-md-4"><em>Self Pay</em></p>
                                                                                        : mainAppointmentModal.InsuranceName ? !isLocationUpdate &&
                                                                                            <p className="text fs-12 text-nowrap d-flex gap-1 align-items-center  ar-pencil col-md-4"> {mainAppointmentModal.InsuranceName}<i className="icon-edit-pencil ar-pencil" onClick={handleLocationChange}></i></p> :
                                                                                            <p className="text fs-12 text-nowrap d-flex gap-1 align-items-center  ar-pencil col-md-4"><em> No Insurance Recorded</em></p>
                                                                                    }
                                                                                </div>
                                                                                {isLocationUpdate &&
                                                                                    <div className=" d-flex align-items-center gap-2">
                                                                                        <div className="input ar-multiple-br">
                                                                                            <SuperSearchList
                                                                                                type="client"
                                                                                                id='InsuranceID'
                                                                                                name='InsuranceID'
                                                                                                searchValue={mainAppointmentModal.InsuranceID}
                                                                                                data={insuranceDD}
                                                                                                onChange={(e) => handleOnChange(e)}
                                                                                                getSelectedData={handleAppointmentSelectedData}
                                                                                                // is={is}
                                                                                                icon={'Simple'}
                                                                                                sup_btn='sup_btn'
                                                                                                sup_inp='superSearchVisitInp'
                                                                                                className="form-control rounded"
                                                                                            />
                                                                                        </div>
                                                                                        <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={handleLocationChange}></i>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            <div className=' d-flex gap-1 hk-details__bottom copay-input'>
                                                                                {!IsCopayUpdate ? <span className='d-flex gap-1 align-items-center'><p className='text fs-11 font-m za-pat-copay copay d-flex gap-1 align-items-center'>Copay: <AmountFormatter amount={patientDetails?.Copay} /> </p><i className="icon-edit-pencil ar-pencil fs-10" onClick={handleCopayChange}></i></span>
                                                                                    : <p className='text fs-11 font-m za-pat-copay d-flex gap-1 align-items-center'>
                                                                                        <div className={"input"}>
                                                                                            <input
                                                                                                className="form-control"
                                                                                                type="text"
                                                                                                name="Copay"
                                                                                                id="Copay"
                                                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                                                                value={patientDetails?.Copay}
                                                                                                onChange={handleOnChangeCopay}
                                                                                            />
                                                                                        </div>
                                                                                        <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={handleCopayChange}></i>
                                                                                    </p>}
                                                                                {!isAmountNull(mainAppointmentModal.CopayPaid) ?
                                                                                    <p className='text fs-11 font-m za-pat-copay pat-bal'>Copay Paid:  {<AmountFormatter amount={mainAppointmentModal.CopayPaid} />}</p>
                                                                                    : null
                                                                                }
                                                                                <p className='text fs-11 font-m za-pat-copay pat-bal'>Balance:  {<AmountFormatter amount={patientDetails.PatientBalance} />}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="hk-details__flex__radios align-items-start">
                                                                            <p className='text fs-12 font-m text-end'>Account # {patientDetails?.AccountNumber || 'N/A'}</p>
                                                                            <div class="form-check form-switch radio_button">
                                                                                <label class="form-check-label" for="mySwitch">Email Notification</label>
                                                                                <input
                                                                                    class="form-check-input"
                                                                                    type="checkbox"
                                                                                    id="EmailNotification"
                                                                                    name="EmailNotification"
                                                                                    onChange={handleOnChange}
                                                                                    checked={mainAppointmentModal.EmailNotification}
                                                                                    autoComplete="off"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                    : <GroupAppointmentPatientSection
                                                        mainAppointmentModal={mainAppointmentModal}
                                                        setMainAppointmentModal={setMainAppointmentModal}
                                                        saveAppointmentModal={saveAppointmentModal}
                                                        setSaveAppointmentModal={setSaveAppointmentModal}
                                                        getAvailableSlotsByParam={getAvailableSlotsByParam}
                                                        handleAppointmentTypeDD={handleAppointmentTypeDD}
                                                        setProvID={setProvID}
                                                        setLocID={setLocID}
                                                        allPatientDetails={allPatientDetails}
                                                        setAllPatientDetails={setAllPatientDetails}
                                                        AppointmentID={AppointmentID}
                                                        getProceduresByAppointmentType={getProceduresByAppointmentType}
                                                    />}
                                                <div className="row m-0 row-gap-8">
                                                    {selectedType === 'Group' ?
                                                        <div className="col-md-12 p-0">
                                                            <div className='input'>
                                                                <div className={appointmentValidation.GroupNameVal ? 'input error' : 'input'}>
                                                                    <label htmlFor="">Group Name
                                                                        {GroupNameRequired && <span style={{ color: 'red' }}>*</span>}
                                                                    </label>
                                                                    <input type="text"
                                                                        className='form-control'
                                                                        name='GroupName'
                                                                        id='GroupName'
                                                                        value={mainAppointmentModal.GroupName}
                                                                        onChange={handleOnChange}
                                                                    />
                                                                    {appointmentValidation.GroupNameVal}
                                                                </div>
                                                            </div>
                                                        </div> : null}
                                                    <div className="col-md-4 ps-0 pe-2">
                                                        <div className={"input ar-multiple-br"}>
                                                            <label>Location<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.LocationID ? "input error" : "input"}>
                                                                <SuperSearchList
                                                                    is={is}
                                                                    type="client"
                                                                    id='LocationID'
                                                                    name='LocationID'
                                                                    searchValue={mainAppointmentModal?.LocationID}
                                                                    data={locationList}
                                                                    onChange={(e) => handleChangeDD(e)}
                                                                    getSelectedData={handleAppointmentSelectedData}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className="form-control rounded"
                                                                    inputError={appointmentValidation.LocationID}
                                                                />
                                                                {appointmentValidation.LocationID}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0 pe-2">
                                                        <div className={"input ar-multiple-br"}>
                                                            <label>Provider<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.ProviderID ? "input error" : "input"}>
                                                                <SuperSearchList
                                                                    is={is}
                                                                    type="client"
                                                                    id='ProviderIDAppointment'
                                                                    name='ProviderID'
                                                                    searchValue={mainAppointmentModal?.ProviderID}
                                                                    data={providersList}
                                                                    onChange={(e) => handleChangeDD(e)}
                                                                    getSelectedData={handleAppointmentSelectedData}
                                                                    // is={is}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className="form-control rounded"
                                                                    inputError={appointmentValidation.ProviderID}
                                                                />
                                                                {appointmentValidation.ProviderID}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 px-0">
                                                        {![0, "0", null].includes(AppointmentID) && selectedType !== 'Group' ?
                                                            <div className={`input ar-multiple-br`}>
                                                                <label>Status<span style={{ color: 'red' }}>*</span></label>
                                                                <div className={"input"}>
                                                                    <div className={`position-relative`}>
                                                                        <SuperSearchList
                                                                            // key={mainAppointmentModal?.AppointmentMode}
                                                                            type="client"
                                                                            id='AppointmentStatusID'
                                                                            name='AppointmentStatusID'
                                                                            searchValue={mainAppointmentModal?.AppointmentStatusID}
                                                                            data={mainAppointmentModal?.AppointmentMode === 'Telehealth' ? appointmentStatusListTeleHealth : appointmentStatusList.filter(item => item.value !== 11 && item.value !== 12)}
                                                                            onChange={(e) => handleOnChange(e)}
                                                                            getSelectedData={handleAppointmentSelectedData}
                                                                            is={is}
                                                                            icon={'Simple'}
                                                                            sup_btn='sup_btn'
                                                                            sup_inp='superSearchVisitInp'
                                                                            className="form-control rounded"
                                                                            isReadOnly={AppointmentIsInFuture}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : <></>}
                                                    </div>
                                                    <div className="col-md-12 px-0">
                                                        <div className={"input"}>
                                                            <label>Chief Complaint
                                                                {CheifComplaintRequired && <span style={{ color: 'red' }}>*</span>}
                                                            </label>
                                                            <div className={appointmentValidation.ChiefComplain ? "input error" : "input"}>
                                                                <div className={"input"}>
                                                                    <textarea className="form-control"
                                                                        name="ChiefComplain"
                                                                        id="ChiefComplain"
                                                                        autoComplete='off'
                                                                        value={mainAppointmentModal.ChiefComplain}
                                                                        onChange={handleOnChange} />
                                                                    {appointmentValidation.ChiefComplain}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0 pe-2">
                                                        <div className="input ar-multiple-br">
                                                            <label>Appointment Type<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.AppointmentTypeID ? "input error" : "input"}>
                                                                <SuperSearchList
                                                                    is={is}
                                                                    type="client"
                                                                    id='AppointmentTypeID'
                                                                    name='AppointmentTypeID'
                                                                    searchValue={mainAppointmentModal.AppointmentTypeID}
                                                                    data={visitTypeList}
                                                                    onChange={(e) => handleChangeDD(e)}
                                                                    getSelectedData={handleAppointmentSelectedData}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className="form-control rounded"
                                                                    inputError={appointmentValidation.AppointmentTypeID}
                                                                    ScrollOutside={true}
                                                                />
                                                                {appointmentValidation.AppointmentTypeID}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0 pe-2">
                                                        <div className="input ar-multiple-br">
                                                            <label>Appointment Mode<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.AppointmentMode ? "input error" : "input"}>
                                                                <SuperSearchList
                                                                    is={is}
                                                                    type="client"
                                                                    id='AppointmentMode'
                                                                    name='AppointmentMode'
                                                                    searchValue={mainAppointmentModal.AppointmentMode}
                                                                    data={AppoimentModeDD}
                                                                    onChange={(e) => handleChangeDD(e)}
                                                                    getSelectedData={handleAppointmentSelectedData}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className="form-control rounded"
                                                                    inputError={appointmentValidation.AppointmentMode}
                                                                    ScrollOutside={true}
                                                                />
                                                                {appointmentValidation.AppointmentMode}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 px-0">
                                                        <div className="input ar-multiple-br">
                                                            <label> Duration<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.DurationID ? "error input" : "input"}>
                                                                <SuperSearchList
                                                                    is={is}
                                                                    type="client"
                                                                    id='DurationID'
                                                                    name='DurationID'
                                                                    searchValue={mainAppointmentModal.DurationID}
                                                                    data={[
                                                                        { value: '15', display: '15' },
                                                                        { value: '30', display: '30' },
                                                                        { value: '45', display: '45' },
                                                                        { value: '60', display: '60' },
                                                                        { value: '75', display: '75' },
                                                                        { value: '90', display: '90' },
                                                                        { value: '120', display: '120' },
                                                                    ]}
                                                                    onChange={(e) => handleChangeDD(e)}
                                                                    getSelectedData={handleAppointmentSelectedData}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className="form-control rounded"
                                                                    inputError={appointmentValidation.DurationID}
                                                                    ScrollOutside={true}
                                                                />
                                                                {appointmentValidation.DurationID}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-5 ps-0 pe-2'>
                                                        <div className={appointmentValidation.AppointmentDate ? "input error" : "input"}>
                                                            <DatePicker
                                                                label="Appointment Date"
                                                                value={mainAppointmentModal.AppointmentDate}
                                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'appointment')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-7 px-0 d-flex align-items-end gap-2">
                                                        <React.Fragment>
                                                            <div className={`input position-relative ${appointmentValidation.AppointmentStart ? 'error' : ''}`} >
                                                                <label>Start Time<span style={{ color: 'red' }}>*</span></label>
                                                                <AvailableSlotsDropdown
                                                                    IsSlotAvailable={IsSlotAvailable}
                                                                    availableStartTimeSlots={availableStartTimeSlots}
                                                                    name={'AppointmentStart'}
                                                                    value={mainAppointmentModal.AppointmentStart}
                                                                    handleOnChangeStartTime={handleOnChangeStartTime}
                                                                    handleOnChange={handleOnChange}
                                                                    inputError={appointmentValidation.AppointmentStart}
                                                                />
                                                                {appointmentValidation.AppointmentStart}
                                                            </div>
                                                        </React.Fragment>
                                                        <div className={"input"}>
                                                            <label>End Time<span style={{ color: 'red' }}>*</span></label>
                                                            <div className={appointmentValidation.AppointmentEnd ? "input error" : "input"}>
                                                                <input type="time" className="form-control" name="AppointmentEnd" id="AppointmentEnd" readOnly value={availableStartTimeSlots.length != 0 ? mainAppointmentModal.AppointmentEnd : ''} />
                                                                {appointmentValidation.AppointmentEnd}
                                                            </div>
                                                        </div>
                                                        {[0, "0", null].includes(AppointmentID) && selectedType !== 'Group' ? <React.Fragment><div className="d-flex align-items-center gap-15">
                                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                                <input type="radio" name="Singular" id="Singular" checked={IsSingular} onChange={handleRecurringPopup} />
                                                                <label className="text ar-orange-text text-nowrap" htmlFor="Singular">Single</label>
                                                            </div>
                                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                                <input type="radio" name="Recurring" id="Recurring" checked={isRepeats} onChange={handleRecurringPopup} />
                                                                <label className="text ar-orange-text text-nowrap" htmlFor="Recurring" >Recurring</label>
                                                            </div>
                                                        </div>
                                                        </React.Fragment> : <React.Fragment></React.Fragment>}
                                                    </div>
                                                    {selectedType === 'Individual' ?
                                                        <>
                                                            <div className="col-md-12 px-0 d-flex align-items-end gap-1">
                                                                <div className={"input w-100"}>
                                                                    <label>Intake Form</label>

                                                                    <div className={"input"}>
                                                                        <div className={"input ar-multiple-br"}>
                                                                            <SuperSearchMultipleClient
                                                                                key={reloadSuperSearch}
                                                                                view={'MultiOptions'}
                                                                                type="client"
                                                                                id="EHRTemplate"
                                                                                name="EHRTemplate"
                                                                                selectedOptionsDisplay='intakeFormIDs'
                                                                                initialSelectedValues={IntakeValue}
                                                                                searchParam={saveAppointmentModal}
                                                                                setSearchParam={setSaveAppointmentModal}
                                                                                options={IntakeDropDown?.filter(item => item.value != -1)}
                                                                                sup_btn="sup_btn-Inp"
                                                                                sup_inp="superSearchVisitInp"
                                                                                ScrollOutside={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {!isNull(mainAppointmentModal?.PatientAppointmentID) && (Array.isArray(IntakeValue) ? IntakeValue : []).length > 0 ? <div className='Intake_form hk-expand-table px-0'>
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th><p className="heading">Intake Form</p></th>
                                                                            <th><p className="heading">Status</p></th>
                                                                            <th><p className="heading d-flex justify-content-center">Action </p></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {(Array.isArray(IntakeValue) ? IntakeValue : [])?.map((form, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td className={`text ${form?.Status === "Awaiting Response" ? "" : 'validate-color cursor-pointer'}`} onClick={(e) => {
                                                                                        if (form?.Status === "Awaiting Response") return;
                                                                                        handleIntakePreview(form?.GuidID, form?.PatientIntakeFormID, form?.PatientID, form?.Status);
                                                                                    }}>{form?.display}</td>
                                                                                    <td className="">
                                                                                        <div className='d-flex align-items-center gap-2'>
                                                                                            <div>
                                                                                                {
                                                                                                    <div className='d-flex align-items-center gap-1'>
                                                                                                        <span className={`pill ${handleStatusColor(form?.Status)}`}>{form?.Status}</span>
                                                                                                        <span class="ar-light-color fst-normal text fst-italic font-m">
                                                                                                            {form?.PatientIntakeFormID && handleStatusBasedActions(form?.Status, () => {
                                                                                                                if (['Awaiting Response', 'Not Sent'].includes(form?.Status)) { handleResendIntakeForm(form?.PatientIntakeFormID) }

                                                                                                                else if (['Submitted'].includes(form?.Status)) { handleIntakePreview(form?.GuidID, form?.PatientIntakeFormID, form?.PatientID, form?.Status) }
                                                                                                            })}</span>
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        {form?.Status === "Deleted" ? <></> :
                                                                                            <div className='d-flex justify-content-center' onClick={() => handleToggleOption(form, 'EHRTemplate')}>
                                                                                                <i className='icon-delete fs-12 clr-danger'></i>
                                                                                            </div>
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div> : <></>}
                                                        </>
                                                        : null}
                                                </div>
                                            </div>
                                            {/* : <groupappointment/> code in notepad file for now} */}
                                        </div>

                                        <div className="tabs-action-bottom mt-2">
                                            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between ar_footer'>
                                                {mainAppointmentModal?.Status ?
                                                    <div className='d-flex align-items-center gap-01'>
                                                        <p className='text font-m fs-12'>Status:</p>
                                                        <p className={`heading fs-12 fst-italic ar-status-clm ${mainAppointmentModal?.IsGroupAppointment ? mainAppointmentModal.GroupStatusDisplay.replace(' ', '-') : String(mainAppointmentModal?.Status).replace(' ', '-')}`}>

                                                            <div className="app_tooltip bottom grossary description claimStatus">
                                                                <p className=' ar-status-clm'>
                                                                    {mainAppointmentModal?.IsGroupAppointment ? mainAppointmentModal.GroupStatusDisplay : mainAppointmentModal.Status}
                                                                </p>
                                                                {!isNull(mainAppointmentModal?.Reason) ? <p className="tool_tip">
                                                                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={mainAppointmentModal?.Reason}> {mainAppointmentModal?.Reason}</span>
                                                                </p> : null}
                                                            </div>
                                                        </p>
                                                    </div> : <div></div>}
                                                <div className="d-flex gap-2 align-items-center">
                                                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => handleAppointmentClose()}>Cancel</button>
                                                    <button className={IsEditAllowed ? "btn btn-validate px-10 h-100" : "btn btn-validate px-10 h-100 disabled"} onClick={() => handleAppointment("appointment")}>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="blockTime">
                                        <AddNewBlockAppointment
                                            handleOnBlockClose={handleOnBlockClose}
                                            providersList={providersList}
                                            locationList={locationList}
                                            handleAppointment={handleAppointment}
                                            IsEditAllowed={IsEditAllowed}
                                            ReasonDD={ReasonDD}
                                            blockAppointmentValidation={blockAppointmentValidation}
                                            mainBlockAppointmentModal={mainBlockAppointmentModal}
                                            handleOnChangeBlock={handleOnChangeBlock}
                                            handleCalendarChange={handleCalendarChange}
                                            BlockAvailableStartTimeSlots={BlockAvailableStartTimeSlots}
                                            BlockAvailableEndTimeSlots={BlockAvailableEndTimeSlots}
                                            handleBlockSelectedData={handleBlockSelectedData}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="ProcedureCodes">
                                        <AddNewCPTAppointment
                                            mainAppointmentModal={mainAppointmentModal}
                                            handleAppointmentClose={handleAppointmentClose}
                                            handleAppointment={handleAppointment}
                                            ProcedureCodeData={ProcedureCodeData}
                                            setProcedureCodeData={setProcedureCodeData}
                                            PatientAppointmentID={AppointmentID}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default React.memo(AddNewAppointment)
